{
    "logo": "セファブルロゴ",
    "add": "追加",
    "all": "全て",
    "edit": "編集",
    "create": "作成する",
    "delete": "消去",
    "previous": "前の",
    "next": "次",
    "search": "検索",
    "loading": "読み込み中...",
    "reload": "リロード",
    "cancel": "キャンセル",
    "copy": "コピー",
    "save": "保存",
    "saveAndFinish": "保存して終了",
    "saveAndContinue": "保存して続行",
    "saved": "保存しました",
    "saveError": "変更の保存中にエラーが発生しました。",
    "done": "終わり",
    "back": "戻る",
    "play": "遊ぶ",
    "pause": "一時停止",
    "success": "成功",
    "continue": "続く",
    "options": "オプション",
    "share": "共有",
    "finish": "仕上げる",
    "description": "説明",
    "expand": "拡大する",
    "expandMenu": "メニューを展開",
    "finishEdit": "編集終了",
    "advancedOptions": "詳細オプションを表示",
    "authenticating": "認証中...",
    "skipToMain": "メインコンテンツへスキップ",
    "skip": "スキップ",
    "close": "近い",
    "notFound": "ページが見つかりません",
    "notFoundDescription": "ああ、大変！海中を探したのですが、ページが見つかりません！",
    "exitSetup": "セットアップを終了",
    "experimental": "実験的",
    "letGetStarted": "さあ始めましょう！",
    "exploreInputControls": "入力コントロールを調べる",
    "when": "私が...",
    "thenMacro": "Cephable は実行されます...",
    "controls": "コントロール",
    "welcome": "いらっしゃいませ。",
    "beta": "ベータ",
    "macroEmpty": "この条件に一致するマクロはありません。",
    "you": "あなた",
    "step": "ステップ",
    "steps": "手順",
    "learnMore": "もっと詳しく知る",
    "dangerZone": "危険地帯",
    "connected": "接続",
    "notConnected": "接続されていません",
    "connectAndLearn": "つながる＆学ぶ",
    "tryAgain": "もう一度やり直してください",
    "by": "投稿者: {{value}}",
    "noName": "- 名前なし -",
    "details": "詳細",
    "controlFeed": "コントロールフィード",
    "upgrade": "アップグレード",
    "purchase": "購入",
    "results": "結果",
    "created": "作成日: {{value}}",
    "updated": "更新: {{value}}",
    "deleted": "削除済み: {{value}}",
    "expires": "有効期限: {{value}}",
    "expired": "期限切れ: {{value}}",
    "used": "使用済み: {{value}}",
    "mobileApp": {
        "title": "モバイルアプリ"
    },
    "dashboard": {
        "title": "ダッシュボード"
    },
    "invalidNumber": "該当なし",
    "wifi": {
        "disconnected": "Wi-Fiが切断されました。",
        "connected": "Wi-Fiが接続されています。",
        "description": "Cephable がお使いの接続およびソフトウェアと連携できるようにするには、Wi-Fi に接続してください。現在のコントロールの使用に制限が生じる場合があります。"
    },
    "signalR": {
        "disconnected": "同期が切断されました。",
        "action": "再接続",
        "description": "Cephable の同期に問題が発生しているようです。設定の保存や他の接続との通信に問題が発生します。",
        "disconnectedDevice": "{{name}} と同期できません。",
        "disconnectedDeviceDescription": "認証またはインターネット接続のいずれかが原因で、同期に問題が発生しているようです。リモートでデータを送受信できません。接続の両側を確認する必要があります。",
        "connected": "同期が接続されました。",
        "connectedDescription": "Cephable は正常に同期しており、期待どおりに接続および拡張機能と通信するはずです。",
        "swap": "ローカルデバイス接続に切り替える",
        "unlinkedDevice": "接続が削除されました。",
        "unlinkedDeviceDescription": "この接続はアカウントからリンク解除されました。"
    },
    "billing": {
        "title": "請求する",
        "expires": "次回の請求: {{value}}",
        "description": "組織の請求、シート、サブスクリプションのアップグレード、更新、またはキャンセルを管理します。",
        "error": "請求を管理するには、システム管理者にお問い合わせください。",
        "view": "請求の管理",
        "isEmployeeAccess": {
            "title": "プロ",
            "titleLong": "セファブルプロフェッショナル",
            "short": "プロ",
            "description": "Cephable Professional は、ローカルのプライベート AI を生成機能に拡張し、ユーザーの生産性をさらに高めます。",
            "supportedFeatures": {
                "tag": "プラスのすべて、プラス",
                "features": [
                    "AIテキスト生成",
                    "AIによる書き換え",
                    "AI翻訳",
                    "無制限のデバイスインストール",
                    "無制限の事前トレーニング済みアプリコントロール",
                    "コントロールの無制限の共有"
                ]
            }
        },
        "isDeveloperAccess": {
            "title": "開発キット",
            "titleLong": "セファブル SDK",
            "short": "SDK",
            "description": "Cephable SDK を使用すると、音声、顔、頭などの強力な適応型コントロールをソフトウェアに統合でき、最小限の手間で最大限の効果が得られます。",
            "supportedFeatures": {
                "tag": "プラスのすべて、プラス",
                "features": [
                    "WindowsとMacOSのサポート",
                    "オフラインでの音声、顔、頭、クイックアクション入力のための軽量で埋め込み可能な SDK",
                    "カスタム出力アクションの API/Webhook サポート",
                    "開発者向けドキュメント",
                    "サンプルプロジェクト",
                    "コマンドをドキュメントの自動化とナビゲーションに変換する",
                    "プロジェクト、認証クライアント、デバイスタイプなどを管理するための開発者ポータル"
                ]
            }
        },
        "isStudentAccess": {
            "title": "学生",
            "titleLong": "セファブル教育",
            "short": "教育",
            "description": "Cephable Educationは、個別学習とインクルーシブな授業をサポートします。Cephableはオフラインでもデバイス上で動作し、サードパーティとの連携は不要です。",
            "supportedFeatures": {
                "tag": "プラスのすべて、プラス",
                "features": [
                    "デバイスのインストール数は無制限",
                    "無制限の事前学習済みアプリコントロール",
                    "カスタムアプリコントロールの無制限の共有"
                ]
            }
        },
        "isResellerAccess": {
            "title": "リセラー",
            "titleLong": "Cephable 再販業者",
            "description": "Cephable Reseller は、新しい組織を作成し、ライセンス キーを割り当てることができる有料ライセンスです。これには、独自のソフトウェア スイートで Cephable を使用し、ユーザー エクスペリエンスを向上させることが含まれます。",
            "short": "リセラー"
        },
        "viewProducts": "製品を見る",
        "included": "{{licenseType}} ライセンスに含まれています。",
        "upgrade": {
            "description": "今すぐアップグレードして、コントロールを次のレベルに引き上げましょう。",
            "action": "今すぐアップグレード",
            "error": "アップグレード中にエラーが発生しました。しばらくしてからもう一度お試しください。",
            "requiredDetail": "この機能には{{licenseType}}ライセンスが必要です。アカウント設定からいつでもアップグレードまたは無料トライアルを開始できます。",
            "enableTextGeneration": "AIと音声を使用してコンテンツを生成します。",
            "longDescription": "有料ライセンスにアップグレードすると、Cephable のすべての機能がご利用いただけるようになります。複数のデバイス、高度な制御、カスタム統合など、Cephable には生産性を次のレベルに引き上げるために必要なものがすべて揃っています。",
            "compare": "プランを比較する",
            "enableAiDictation": {
                "title": "インテリジェントディクテーションにアップグレード",
                "description": "アップグレードすると、AIによる高度なディクテーション機能が利用可能になります。句読点の追加、大文字の修正、そしてあなたのスタイルに合わせた調整ができるので、余分な手間をかけずに洗練された文章を作成できます。"
            }
        },
        "isPlusAccess": {
            "title": "プラス",
            "titleLong": "セファブルプラス",
            "short": "プラス",
            "description": "Cephable Plus は、インテリジェントな音声、インテリジェントなディクテーション、数百のアプリコントロールなどを活用して、より多くのことを行いたいパワーユーザー向けです。",
            "supportedFeatures": {
                "tag": "ベーシックのすべてに加えて",
                "features": [
                    "インテリジェント音声コントロール（自然言語）",
                    "インテリジェントディクテーション（AI強化）",
                    "最大3台のデバイスにインストール可能",
                    "数百の事前トレーニング済みアプリコントロール"
                ]
            }
        },
        "personal": {
            "short": "基本",
            "title": "基本",
            "titleLong": "セファブル ベーシック",
            "description": "Cephable Basicは永久無料で、より速く動き、自分らしさを表現し、自分らしい方法で物事を成し遂げられるよう設計されています。Basicに含まれる機能はすべてのユーザーがご利用いただけます。"
        },
        "mostPopular": "最も人気のある",
        "subscription": {
            "options": "サブスクリプションオプション",
            "monthly": "月払い",
            "billedMonthly": "/月",
            "yearly": "年払い",
            "billedYearly": "/年"
        }
    },
    "organization": {
        "title": "組織",
        "titlePlural": "組織",
        "titleLong": "組織向けCephableプロフェッショナル",
        "description": "組織とは、プロジェクトで共同作業したり、リソースを共有したりできるユーザーのグループです。ここでは、チーム、チーム プロファイル、請求などを管理できます。",
        "viewOrganization": "組織を表示",
        "orgName": "組織名",
        "orgCustomBillingUrl": {
            "title": "カスタム請求 URL",
            "description": "これは、ユーザーを（再販業者の）課金システムにリダイレクトするために使用されるカスタム URL です。「https://」または「mailTo:」で始まる必要があります。"
        },
        "create": "新しい組織を作成する",
        "managed": {
            "title": "管理対象組織",
            "titleShort": "管理",
            "titlePlural": "管理対象組織",
            "description": "管理対象組織は、Cephable リセラーによって管理される組織です。リセラーはここでチーム、チーム プロファイル、請求などを管理できます。",
            "error": "管理対象組織の読み込み中にエラーが発生しました。",
            "empty": {
                "title": "管理対象の組織が見つかりません。",
                "description": "この条件に一致する管理対象組織が存在しないようです。または、ライセンス キーがまだアクティブ化されていません。"
            }
        },
        "settings": {
            "title": "組織設定",
            "description": "組織の請求、名前、説明、リソースを管理します。",
            "view": "表示設定",
            "general": {
                "title": "一般的な"
            },
            "resources": {
                "edit": "リソースを編集",
                "description": "左側の Markdown エディターを使用して、組織のすべてのメンバーに役立つリソースを更新およびフォーマットします。入力すると、右側のプレビューにコンテンツがユーザーにどのように表示されるかが表示されます。Markdown 構文を使用して、見出し、リスト、リンク、その他の書式設定要素を追加できます。変更は保存するとメンバーに表示されます。"
            },
            "other": {
                "title": "その他の設定",
                "description": "組織の請求、名前、説明、リソースを管理します。"
            }
        },
        "menu": {
            "title": "組織メニュー",
            "view": "表示メニュー",
            "expand": "メニューを展開"
        },
        "update": "組織が更新されました。アプリを更新しています。",
        "noAccess": {
            "title": "アクセスが拒否されました。",
            "description": "最近権限が変更されたため、この機能にアクセスできなくなりました。エラーだと思われる場合は、組織の管理者にお問い合わせください。"
        },
        "noOrg": {
            "title": "関連するライセンスはありません。",
            "description": "現在、ライセンスまたは開発者グループに関連付けられていません。このポータルは、有料のCephableライセンスをお持ちのユーザーのみご利用いただけます。Cephableの潜在能力を最大限に引き出すには、リスクフリーのトライアルをご利用ください。"
        },
        "error": "組織の読み込み中にエラーが発生しました。しばらくしてからもう一度お試しください。",
        "member": {
            "title": "メンバー",
            "titlePlural": "メンバー",
            "orgTitle": "{{value}} メンバー",
            "me": "私の会員資格",
            "aboutMe": "私について",
            "description": "メンバーとは、組織に所属するユーザーです。メンバーにはさまざまな役割を割り当てることができ、組織のさまざまな部分にアクセスできます。",
            "edit": "メンバーを編集",
            "removed": "チームから削除されました。",
            "removedDescription": "チームから削除されました。組織にアクセスできなくなりました。エラーだと思われる場合は、組織の管理者に問い合わせてください。",
            "updated": "成功しました。{{value}} のメンバーシップが更新されました。",
            "error": "{{value}} のメンバーシップの更新中にエラーが発生しました。",
            "delete": "成功しました。{{value}} が削除されました。",
            "deleteError": "{{value}} の削除中にエラーが発生しました。",
            "loadError": "組織メンバーの読み込み中にエラーが発生しました。",
            "deleteConfirmation": {
                "title": "このメンバーを削除してもよろしいですか?",
                "description": "このメンバーを削除すると、そのメンバーは組織にアクセスできなくなります。後からいつでも再度招待できます。",
                "confirm": "はい、メンバーを削除します"
            },
            "viewAll": {
                "title": "すべてのメンバーを表示",
                "description": "組織のすべてのメンバーを表示し、その役割と権限を管理します。"
            },
            "seats": {
                "title": "会員席",
                "description": "組織内のすべてのメンバーがシートとしてカウントされます。メンバーが持つ権限の種類は、組織管理者が変更できます。",
                "stats": "{{value}} 席中",
                "max": "最大座席数",
                "maxSeatValue": "最大座席数: {{value}}",
                "current": "現在の座席",
                "limit": {
                    "title": "座席数が上限に達しました",
                    "description": "現在のプランの利用可能な座席数の上限である {{ maxSeats }} に達しました。追加メンバーを招待することはできません。プランをアップグレードするか、座席の割り当てを管理するには、管理者に問い合わせてください。"
                },
                "updateLimit": {
                    "title": "プランをアップグレードして座席数を増やす",
                    "description": "現在のプランは最大シート数に達しました: {{ maxSeats }}。今すぐアップグレードして追加シートのロックを解除し、チームがシームレスに成長し続けることができるようにしてください。",
                    "action": "アップグレードプラン"
                }
            },
            "emailExists": "組織内に既に電子メールが存在します。別の電子メール アドレスを入力してください。"
        },
        "invite": {
            "title": "招待する",
            "titlePlural": "招待",
            "orgTitle": "{{ value }} 招待",
            "description": "組織に参加するための招待状がユーザーに送信されます。組織に参加するようユーザーを招待し、さまざまな役割を割り当てることができます。",
            "edit": "メンバーを追加する",
            "view": "すべての招待を表示",
            "viewDescription": "現在承認されていないすべての招待を表示します。",
            "new": "メンバーを招待する",
            "emailRequired": "メールアドレスは必須です",
            "emailInvalid": "電子メールが無効です。有効な電子メール アドレスを入力してください。",
            "emailExists": "メールアドレスには既に組織への招待状があります。別のメールアドレスを入力してください。",
            "emailPlaceholder": "メールアドレスを入力してください",
            "expiration": "期限切れ",
            "delete": "招待を削除",
            "confirm": "この招待を削除してもよろしいですか?",
            "confirmLong": "この招待を削除すると、ユーザーは組織に参加できなくなります。後からいつでも再度招待できます。",
            "accept": "招待を承諾",
            "stat": "アクティブな招待",
            "error": "招待の読み込み中にエラーが発生しました。",
            "noInvites": {
                "title": "招待はありません。",
                "description": "あなたの組織にはアクティブな招待がないようです。"
            },
            "acceptSuccess": {
                "title": "チームへようこそ。",
                "description": "組織への参加が完了しました。",
                "action": "新しい組織を表示する"
            },
            "acceptError": {
                "title": "おっと。問題が発生したようです。",
                "description": "組織への参加中にエラーが発生しました。しばらくしてからもう一度お試しください。問題が解決しない場合は、組織の管理者に問い合わせてください。",
                "action": "ホームページに戻る"
            },
            "send": {
                "title": "招待を送信",
                "success": "{{value}} への招待が送信されました。",
                "error": "{{value}} への招待の送信中にエラーが発生しました。"
            },
            "editDescription": "ユーザーが組織に参加するための新しい招待状を作成します。"
        },
        "role": {
            "title": "役割",
            "titlePlural": "役割",
            "description": "役割とは、組織内でユーザーが持つことができるさまざまなアクセス レベルです。ユーザーにさまざまな役割を割り当てて、ユーザーが実行できる操作を制御できます。"
        },
        "isAdmin": {
            "title": "管理者",
            "description": "管理者は組織への完全なアクセス権を持ち、組織のあらゆる側面を管理できます。",
            "conflict": "このメンバーは管理者です。役割を編集する権限がありません。"
        },
        "canViewMembers": {
            "title": "メンバーを表示",
            "description": "この権限を持つユーザーは、組織のすべてのメンバーを表示できます。"
        },
        "canInviteMembers": {
            "title": "メンバーを招待",
            "description": "この権限を持つユーザーは、組織に新しいメンバーを招待したり、既存の招待を管理したりできます。"
        },
        "canChangeMemberPermissions": {
            "title": "メンバーの役割を変更する",
            "description": "この権限を持つユーザーは、組織内の他のメンバーの役割を変更できます。"
        },
        "canRemoveMembers": {
            "title": "メンバーを削除",
            "titleSingle": "メンバーを削除",
            "action": "取り除く",
            "description": "この権限を持つユーザーは、組織から他のメンバーを削除できます。",
            "confirm": "このメンバーを組織から削除してもよろしいですか?",
            "confirmLong": "このメンバーを削除すると、そのメンバーは組織にアクセスできなくなります。後からいつでも再度招待できます。"
        },
        "canCreateAuthClients": {
            "title": "プロジェクトを作成する",
            "description": "この権限を持つユーザーは、組織に対して新しい認証クライアントとプロジェクトを作成できます。"
        },
        "canManageBilling": {
            "title": "請求の管理",
            "description": "この権限を持つユーザーは、組織の課金設定を管理できます。",
            "error": "この組織の請求を管理する権限がありません。"
        },
        "canManageChildOrganizations": {
            "title": "子組織の管理",
            "description": "この権限を持つユーザーは、管理者として子組織を作成および管理できます。"
        },
        "canViewAnalytics": {
            "title": "分析を表示",
            "description": "この権限を持つユーザーは、組織の指標と分析を表示できます。"
        },
        "metrics": {
            "title": "メトリクス",
            "description": "メトリックは、組織が Cephable をどのように使用しているかを理解するのに役立つデータ ポイントです。",
            "view": "指標を表示",
            "orgTitle": "{{ value }} メトリック",
            "lineChart": {
                "title": "平均同時接続数",
                "description": "このグラフには、組織とプロジェクト データの平均同時接続数が時間の経過とともに表示されます。",
                "max": "最大接続数: {{maxConnections}}",
                "project": "プロジェクト合計",
                "org": "組織合計"
            },
            "manage": {
                "title": "パフォーマンスメトリック",
                "description": "モデル推論中に収集されたパフォーマンス メトリックをダウンロードまたはクリアします。"
            },
            "download": {
                "button": "ダウンロードメトリクス",
                "success": "メトリック ファイルはダウンロード フォルダーに保存されました。",
                "error": "メトリック ファイルのダウンロードに失敗しました。",
                "noFile": "メトリクスファイルが見つかりません。まずはモデルを実行してみてください。"
            },
            "clear": {
                "button": "明確な指標",
                "success": "メトリックがクリアされました。",
                "error": "メトリック ファイルのクリアに失敗しました。",
                "confirm": {
                    "title": "明確なパフォーマンス指標",
                    "description": "記録されたすべてのパフォーマンス メトリックをクリアしてもよろしいですか? この操作は元に戻せません。",
                    "cancel": "キャンセル",
                    "confirm": "明確な指標"
                }
            }
        },
        "projects": {
            "title": "プロジェクト",
            "description": "プロジェクトを使用して、安全なアクセスを管理し、デバイスのインタラクションを構成し、さまざまなプラットフォーム間でアプリがコマンドを送受信する方法を効率化します。",
            "name": "アプリ名",
            "view": "プロジェクトを見る",
            "error": "プロジェクトの読み込み中にエラーが発生しました。",
            "orgTitle": "{{ value }} プロジェクト",
            "stats": {
                "title": "プロジェクト統計",
                "connections": "合計接続数",
                "all": {
                    "title": "すべてのプロジェクト指標",
                    "description": "{{ orgName }} に関連付けられているすべてのプロジェクトの集計メトリック"
                },
                "card": "{{value}} 個のプロジェクトのうち",
                "users": "{{date}} 以降の合計ユーザー数",
                "avgUsers": "月間平均ユーザー数。",
                "concurrent": {
                    "title": "過去 {{days}} 日間の平均同時接続数",
                    "label": "平均同時接続数",
                    "max": "最大接続数",
                    "overage": "超過料金",
                    "description": "同時接続とは、プロジェクトに同時に接続しているユーザーの数です。この指標は、同時にアプリを使用しているユーザーの数を把握するのに役立ちます。"
                }
            },
            "projectType": {
                "title": "プロジェクトタイプ",
                "description": "プロジェクト タイプはプロジェクトを分類し、適切な SDK を選択するために使用されます。"
            },
            "accessDenied": {
                "generic": "このプロジェクトへのアクセス権がありません。",
                "title": "アクセスが拒否されました。",
                "description": "プロジェクトを表示、作成、編集、削除する権限がありません。アクセス権については管理者に問い合わせてください。"
            },
            "upgrade": {
                "title": "Cephable SDK へのアップグレード",
                "description": "Cephable は、SDK を使用してアプリ、ゲーム、またはサービスに直接統合できます。現在、プロジェクトはお客様のアカウントではご利用いただけません。間違いがあると思われる場合は、support@cephable.com までご連絡ください。",
                "shortDescription": "現在、あなたのアカウントではプロジェクトを利用できません。アップグレードするにはお問い合わせください。"
            },
            "limit": {
                "title": "もっとプロジェクトが欲しいですか?",
                "error": "プロジェクトの制限に達しました。",
                "description": "組織のプロジェクト数の上限に達しました。管理者に連絡してアカウントをアップグレードしてください。"
            },
            "create": {
                "title": "プロジェクトを作成",
                "titleLong": "始めましょう。",
                "first": {
                    "title": "プロジェクトを始めましょう。",
                    "description": "まだプロジェクトを作成していないようです。クライアント キーとデバイスは、アプリケーションと当社のサービス間の通信を安全にするために不可欠です。クライアント キーを使用すると、音声とヘッド モーション コントロールをアプリに迅速かつ安全に統合できます。"
                },
                "details": {
                    "title": "プロジェクトの詳細",
                    "description": "アプリケーションの認証、デバイス機能、SDK 統合を管理するには、新しいプロジェクトを作成します。以下の手順に従って、ユーザー向けに安全でカスタマイズ可能なインタラクションを設定します。"
                }
            },
            "sdk": {
                "title": "SDKをダウンロード",
                "description": "適応型コントロールを簡単にするために開発された強力な SDK にアクセスできます。",
                "select": {
                    "title": "SDKを選択",
                    "description": "このプロジェクトで使用する SDK を選択します。当社の SDK を使用すると、さまざまなプラットフォーム間で適応型音声およびヘッド モーション コントロールをシームレスに統合できます。"
                }
            },
            "clients": {
                "title": "認可クライアント",
                "configure": "認証クライアントの設定",
                "description": "承認クライアントは、アプリケーションへの安全なアクセスを管理します。承認クライアントを定義して、ユーザーを認証し、アプリケーションとのやり取りを制御します。",
                "settings": "認証設定",
                "create": "承認クライアントの作成",
                "max": "最大プロジェクト数: {{value}}"
            },
            "secret": {
                "title": "クライアントシークレット",
                "created": "クライアントシークレットが作成されました。",
                "description": "クライアント シークレットは 1 回だけ表示されます。今すぐコピーして、安全な場所に保管してください。<br><br>ご自身の開発にのみ使用してください。サードパーティのサービスやアプリケーションと共有しないでください。",
                "copy": "シークレットをコピー",
                "rotate": {
                    "title": "クライアントシークレットのローテーション",
                    "description": "警告: このアクションにより、既存のクライアント シークレットが取り消され、新しいクライアント シークレットが作成されます。このため、アプリ全体で既存の使用状況をすべて更新する必要があります。このアクションを元に戻すことはできません。",
                    "error": "シークレットのローテーション中にエラーが発生しました。しばらくしてからもう一度お試しください。"
                }
            },
            "key": {
                "title": "クライアントキー",
                "view": "クライアントキーを表示",
                "copy": "キーをコピー",
                "delete": {
                    "title": "クライアントキーの削除",
                    "description": "警告: この操作により、既存のクライアント キーと関連するすべての設定が削除されます。この操作を元に戻すことはできません。",
                    "error": "クライアント キーの削除中にエラーが発生しました。",
                    "success": "プロジェクトは削除されました。"
                }
            },
            "tokenRedirect": {
                "title": "トークンリダイレクト URL",
                "description": "トークン リダイレクト URL は、認証が完了した後にアクセス トークンが送信されるエンドポイントです。これらの URL を使用すると、アプリケーションはユーザー データやサービスにアクセスするために必要なトークンを安全に受信できます。"
            },
            "authRedirect": {
                "title": "認証コードリダイレクト URL",
                "description": "AuthCode リダイレクト URL は、ユーザーがアプリケーションに権限を付与した後に認証コードが送信されるエンドポイントです。この URL は、OAuth フローに不可欠です。認証サーバーからアプリへの認証コードの安全な送信を保証し、ユーザーに代わってアクセス トークンを要求できるようにするためです。"
            },
            "originHost": {
                "title": "元のホスト",
                "description": "API のやり取り中にリクエストとデータの主なソースとして機能する URL。"
            },
            "scopes": {
                "title": "スコープ",
                "configure": "スコープを定義する",
                "titleLong": "API 権限スコープ",
                "manage": "承認スコープの管理",
                "description": "スコープは、この承認クライアントが持つ権限を定義します。スコープを設定して特定のデータと機能へのアクセスを制限し、ユーザーが必要なアクセスのみを取得できるようにします。"
            },
            "type": {
                "title": "実装タイプ"
            },
            "deviceScopes": {
                "title": "関連デバイスの種類",
                "titles": "関連デバイスの種類",
                "titleLong": "許可されるデバイスの種類",
                "configure": "許可されるデバイスの種類を設定する",
                "descriptionShort": "このプロジェクトにアクセスできるデバイスのタイプを定義します。",
                "description": "デバイス タイプは、アプリケーション内でデバイスが持つ権限とアクセス レベルを定義します。特定のデバイス タイプを割り当てることで、各デバイスがアクセスできるアクションとデータを制御でき、アプリケーションのセキュリティを維持し、プライバシー ポリシーに準拠することができます。",
                "action": "新しいデバイスタイプを追加"
            },
            "deviceType": {
                "title": "デバイスの種類",
                "description": "DeviceType は、デバイスのカテゴリを定義し、その入出力機能とサポートされる機能 (音声、ジェスチャ、コントローラの種類など) を詳細に説明します。これにより、承認されたデバイスのみがアプリケーションと対話できるようになります。",
                "action": "デバイスタイプの作成",
                "name": "デバイスタイプ名",
                "descriptionLong": "デバイスタイプの説明",
                "id": "デバイスタイプID",
                "features": {
                    "title": "サポート機能",
                    "description": "アプリがサポートする入力と出力を定義します。これにより、Cephable 全体のユーザー エクスペリエンスを最適化できます。",
                    "supportsVoiceInput": "音声入力",
                    "supportsPhysicalInput": "物理的入力",
                    "supportsKeyboardOutput": "キーボード出力",
                    "supportsPlayStationControllerOutput": "プレイステーション コントローラー",
                    "supportsFaceInput": "顔入力",
                    "supportsGestureInput": "ジェスチャー入力",
                    "supportsXboxControllerOutput": "Xbox コントローラー",
                    "supportsDigitalExtensions": "デジタル拡張機能",
                    "supportsPhysicalExtensions": "物理的な拡張",
                    "supportsNintendoControllerOutput": "任天堂コントローラー",
                    "supportsGenericControllerOutput": "汎用コントローラ出力"
                },
                "canAutoStart": {
                    "title": "自動制御スタートをサポート",
                    "description": "[canAutoStart] を有効にすると、SDK はユーザー設定を確認し、ユーザーのログイン後にカメラまたはマイクのコントロールをすぐに開始しようとします。"
                },
                "isSupported": {
                    "title": "アクティブ",
                    "description": "[isSupported] 無効にすると、Cephable はこれに関連付けられたユーザーデバイスを送信、受信、または確認しなくなります。非推奨に相当します。"
                },
                "locale": {
                    "title": "デフォルト言語",
                    "description": "[defaultLocale] このデバイス タイプのデフォルトのロケール。これはデバイスのデフォルト言語として使用されます。",
                    "support": "サポート言語",
                    "warn": "** カスタム コントロールが設定されているようです。関連する言語のカスタム コントロールが更新されていることを確認してください。**",
                    "name": "{{lang}} - デバイスタイプ名",
                    "langDescription": "{{lang}} - 説明"
                },
                "customControls": {
                    "title": "カスタムコントロール",
                    "object": "{{lang}} - カスタム コントロール オブジェクト",
                    "description": "カスタム コントロールは、ユーザーがこのデバイスに関連付けられたアプリ コントロールを手動で設定および編集できるようにする高度なオプションです。ユーザーが Cephable から直接デバイスを制御できるようにするには、ここでデバイス コントロールを登録する必要があります。オプションの詳細については、Cephable API を参照してください。"
                },
                "success": {
                    "title": "成功！",
                    "description": "新しいデバイス タイプを作成しました。{{name}} 必要に応じて、認証クライアントのデバイス スコープを更新できるようになりました。"
                }
            }
        },
        "new": {
            "details": "組織の詳細",
            "name": {
                "label": "組織名",
                "placeholder": "組織名を入力してください"
            },
            "description": {
                "label": "組織の説明",
                "placeholder": "Cephable Professional を使用する目的は何ですか?"
            }
        },
        "expired": {
            "user": "Cephable ライセンスの有効期限が切れているようです。更新するには、組織の管理者に問い合わせてください。",
            "admin": "Cephable ライセンスの有効期限が切れているようです。アプリを引き続き使用するには、ライセンスを更新してください。",
            "multiple": "Cephable ライセンスの有効期限が切れているようです。アプリを引き続き使用するには、少なくとも 1 つのライセンスを更新してください。",
            "dialog": {
                "title": "組織を選択",
                "description": "アカウントには複数の組織が関連付けられています。更新する組織を選択してください。"
            },
            "title": "Cephableライセンスの有効期限が切れました",
            "titlePlural": "Cephableライセンスの有効期限が切れました",
            "banner": "Cephable Premiumライセンスの有効期限が切れているようです。更新すると、強化された音声コントロール、AIインテリジェントタスク、そして多数のプリビルドアプリコントロールなどの機能にアクセスできるようになります。"
        },
        "upgrade": {
            "existing": {
                "title": "あなたは既存のライセンスの一部です。",
                "description": "サイドメニューの `{{action}}` をクリックしてアップグレードしてください。"
            }
        },
        "restrictions": {
            "isGenAIDisabled": {
                "title": "生成AIが無効",
                "description": "組織ではGenerative AI機能へのアクセスが無効になっています。詳細については、組織の管理者にお問い合わせください。"
            },
            "isRemoteControlDisabled": {
                "title": "クロスデバイス同期が無効",
                "description": "組織によって同期へのアクセスが無効になっているため、コンパニオンアプリの使用や外部デバイスの操作はできません。詳しくは、組織の管理者にお問い合わせください。"
            }
        },
        "troubleshooting": {
            "title": "トラブルシューティング",
            "editorDescription": "[オプション] これは、Cephable モバイル アプリとデスクトップ アプリの両方の接続詳細ページを通じてすべてのユーザーに表示されるセクションです。",
            "description": "Cephable で問題が発生している場合は、以下の手順を試して一般的な問題を解決してください。"
        },
        "onboarding": {
            "title": "オンボーディング",
            "editorDescription": "[オプション] このデバイスタイプがユーザーのアカウントに追加されると、オンボーディングが表示されます。この欄は、アプリケーションでこのデバイスタイプを設定して使用する方法についての説明を提供するのに最適です。"
        },
        "documents": "文書",
        "completionStatus": {
            "title": "完了ステータス",
            "error": "",
            "complete": "完了。",
            "incomplete": "不完全。"
        },
        "metadata": {
            "title": "メタデータ",
            "urlError": "URL は http:// または https:// で始まる必要があります",
            "metatitle": {
                "label": "メタタイトル",
                "placeholder": "短いタイトルを入力してください"
            },
            "shortDescription": {
                "label": "簡単な説明",
                "placeholder": "簡単なプレビューの説明を入力してください（最大 150 文字）"
            },
            "externalLink": {
                "label": "外部リンクURL",
                "placeholder": "https://example.com/デバイス情報",
                "description": "このデバイスの初回設定に関する詳細情報を提供する外部ウェブサイトまたはリソースへの直接リンクです。これを使用すると、クライアントリストのマークダウンは使用されません。"
            },
            "iconUrl": {
                "label": "デバイスアイコンURL",
                "placeholder": "https://example.com/デバイスアイコン.png",
                "description": "このデバイスタイプを表す画像への直接リンク。このアイコンはCephableアプリとデバイスリストに表示されます。"
            },
            "darkModeIconUrl": {
                "label": "ダークモードデバイスアイコンURL",
                "placeholder": "https://example.com/device-icon-dark.png",
                "description": "このデバイスタイプをダークモードで表示する画像への直接リンクです。このアイコンは、ユーザーがダークモードを有効にしている場合、Cephableアプリとデバイスリストに表示されます。"
            },
            "editorDescription": "お使いのデバイスが Cephable アプリで拡張機能または接続として表示されるように選択された場合、この情報は新しい接続を設定するユーザーに表示するために使用されます。"
        },
        "client-listing": {
            "title": "クライアントリスト",
            "editorDescription": "新規ユーザーがこのデバイスタイプで新しい接続を設定するための詳細な手順。このマークダウンコンテンツは、ユーザーが新しい接続を追加するときにCephableアプリに表示されます。"
        }
    },
    "developer": {
        "title": "開発者",
        "titleLong": "開発者リソース",
        "description": "Cephable は、当社の SDK を使用してアプリ、ゲーム、またはサービスに直接統合できます。",
        "sdk": {
            "title": "SDK を詳しく見る",
            "description": "当社は、音声認識と適応型コントロールをアプリケーションにシームレスに統合するように設計された一流の SDK を提供しています。当社のツールは、直感的なコントロールを通じてユーザー インタラクションを強化し、アクセシビリティを促進するように作成されており、すべてのユーザーがソフトウェアをより効率的に操作できるようにします。",
            "javascript": {
                "title": "JavaScript",
                "subtitle": "ウェブ",
                "description": "音声および適応型コントロールを Web アプリケーションに直接統合します。",
                "action": "NPM パッケージを入手"
            },
            "net": {
                "title": "。ネット",
                "subtitle": "Windows アプリケーション",
                "description": ".NET のパワーを活用して、WPF および WinUI3 SDK を使用してアプリケーションを作成します。",
                "actionCore": "コアパッケージを入手",
                "actionWpf": "WPF パッケージを入手"
            },
            "android": {
                "title": "アンドロイド",
                "subtitle": "モバイルデバイス",
                "description": "音声と頭の動きの機能を容易にするために設計された Android アプリケーション。",
                "action": "Android SDKを入手"
            },
            "more": {
                "title": "もっと",
                "description": "必要なものが見つかりませんか? ご連絡いただければお手伝いいたします。",
                "action": "SDKをリクエストする"
            }
        },
        "demo": {
            "title": "デモ",
            "samples": "デモとサンプル",
            "titleLong": "当社のSDKを実際に体験してください",
            "description": "サンプル アプリケーションを通じて、音声およびヘッド モーション コントロール テクノロジーの威力をご確認ください。インタラクティブ ゲームから動的な Web アプリやモバイル アプリまで、それぞれの例で SDK の汎用性と有効性が実証されています。これらの例を調べて、強化されたアクセシビリティと没入型エクスペリエンスを独自のプロジェクトに統合するための洞察とインスピレーションを得てください。",
            "game": {
                "title": "2048 ゲーム",
                "subtitle": "ウェブ",
                "description": "アダプティブ音声とヘッドモーションコントロールで従来のゲームプレイを向上させます。",
                "action": "ゲームをプレイする"
            },
            "other": {
                "title": "その他のデモ",
                "description": "Cephable がアプリケーション、ゲーム、デバイスをどのように強化できるかを直接体験してください。",
                "action": "その他のデモを見る"
            },
            "web": {
                "title": "Web SDK サンプル",
                "subtitle": "ウェブ",
                "description": "すべてのコア機能を Web アプリケーションに簡単に統合します。",
                "action": "SDKを体験する"
            },
            "unity": {
                "title": "団結",
                "subtitle": "ゲーム開発",
                "description": "アダプティブ コントロールをゲームで活用して、より魅力的な UX を提供する方法をご覧ください。",
                "action": "サンプルを入手"
            }
        },
        "other": {
            "title": "その他のリソース",
            "description": "弊社の SDK で必要なものが見つからない場合は、API を直接操作するか、コミュニティに連絡してヘルプ、インスピレーション、サポートを求めてください。",
            "api": {
                "title": "API",
                "description": "当社の API を使用すると、Cephable と直接やり取りできます。当社の API を使用してカスタム統合を作成できます。"
            },
            "support": {
                "title": "サポート",
                "description": "必要なものが見つかりませんか? Discord 経由でコミュニティにご連絡ください。",
                "action": "Discordに参加する"
            }
        }
    },
    "customControls": {
        "title": "グローバルおよびデバイスコントロール",
        "prefixDisclaimer": "これはプレフィックス制御です。コマンドの後の単語をリッスンし、次のフレーズを検索して一致するものを見つけます。",
        "allowPausedDisclaimer": "このコントロールは、マイクが一時停止されている場合でも機能します。",
        "resetControls": {
            "title": "コントロールをリセット",
            "description": "最後にコントロールを更新してから音声言語が変更されました。注: これにより、コントロールが {{language}} に一致するようにリセットされ、カスタム コマンドが失われる可能性があります。リセットしてもよろしいですか?",
            "confirm": "はい、コントロールをリセットします",
            "error": "コントロールのリセット中にエラーが発生しました。しばらくしてからもう一度お試しください。"
        },
        "conflictIndicators": {
            "warn": "警告： ",
            "title": "入力構成の競合が検出されました",
            "globalControls": "グローバル制御構成の競合",
            "deviceControls": "デバイス制御構成の競合",
            "usedInput": "入力として使用される",
            "description": "使用しているグローバル コントロールとデバイス コントロールの入力の一部は、1 つ以上のアプリ コントロールでも使用されています。これにより、Cephable の使用時に競合が発生する可能性があります。このような状況が発生した場合、グローバル コントロールやデバイス コントロールよりもアプリ コントロールが常に優先されます。",
            "item": "入力<strong>{{value}}</strong>はアプリのコントロールで使用されます: ",
            "globalDescription": "次のグローバル コントロールには、アプリ コントロールと競合する入力があります。",
            "deviceDescription": "次のデバイス コントロールには、アプリ コントロールと競合する入力があります。"
        },
        "globalControls": {
            "title": "グローバルコントロール",
            "empty": "グローバル コントロールはまだありません。以下をクリックして作成してください。",
            "edit": "グローバルコントロールを編集",
            "description": "グローバル コントロールは、使用しているアプリ コントロールやデバイスに関係なく、常に利用できるコントロールです。マイクやカメラのコントロールが一時停止されているときでも機能するコントロールもあります。"
        },
        "deviceControls": {
            "title": "デバイスコントロール",
            "empty": "デバイス コントロールがまだありません。以下をクリックして作成してください。",
            "edit": "デバイスコントロールを編集する",
            "controls": {
                "cephable-open-app": {
                    "success": "アプリを開く: {{value}}",
                    "error": "アプリが見つかりません: {{value}}"
                },
                "cephable-close-app": {
                    "commands": ["近い"],
                    "name": "名前でアプリを閉じる",
                    "description": "このコマンドを音声コントロールとともに使用して、コンピューター上のアプリを名前で閉じます。",
                    "success": "アプリを閉じる: {{value}}",
                    "error": "アプリが見つかりません: {{value}}"
                },
                "cephable-minimize-focused-app": {
                    "commands": ["最小化"],
                    "name": "現在フォーカスされているアプリを最小化します。",
                    "description": "このコマンドを音声コントロールとともに使用すると、現在フォーカスされているアプリが最小化されます。",
                    "success": "集中したアプリの成功を最小限に抑えます。",
                    "error": "フォーカスされたアプリを最小化するときにエラーが発生しました。"
                },
                "cephable-maximize-focused-app": {
                    "commands": ["最大化する"],
                    "name": "現在フォーカスされているアプリを最大化します。",
                    "description": "このコマンドを音声コントロールとともに使用すると、現在フォーカスされているアプリが最大化されます。",
                    "success": "集中的なアプリの成功を最大化しましょう!",
                    "error": "フォーカスされたアプリを最小化するときにエラーが発生しました。"
                },
                "cephable-generate-text": {
                    "commands": ["生成する"],
                    "name": "このコマンドの後にプロンプトを指定してテキストを生成します。",
                    "description": "このコマンドを音声コントロールとともに使用し、その後にプロンプトを入力して、関連するテキストを生成します。"
                },
                "cephable-stop-generate-text": {
                    "commands": ["生成を停止", "生成を停止する", "キャンセル生成", "生成をキャンセル"],
                    "name": "テキストの生成を停止します。",
                    "description": "音声コントロールでこのコマンドを使用すると、テキストの生成が停止します"
                },
                "cephable-open-panel": {
                    "commands": ["パネルを表示"],
                    "name": "Cephableパネルを開く",
                    "description": "音声コントロールでこのコマンドを使用して、Cephable パネルを開きます。"
                },
                "cephable-close-panel": {
                    "commands": ["パネルを非表示"],
                    "name": "Cephableパネルを非表示にする",
                    "description": "音声コントロールでこのコマンドを使用すると、Cephable パネルを非表示にしたり最小化したりできます。"
                },
                "cephable-close-focused-app": {
                    "commands": ["近い流れ"],
                    "name": "現在フォーカスされているアプリを閉じます。",
                    "description": "このコマンドを音声コントロールで使用して、現在フォーカスされているアプリを閉じます。",
                    "success": "現在のアプリを正常に閉じました!",
                    "error": "現在のアプリを閉じるときにエラーが発生しました。"
                },
                "cephable-rewrite-text": {
                    "commands": ["リライト"],
                    "name": "このコマンドの後にプロンプトを指定してテキストを書き換えます。",
                    "description": "音声コントロールに続いてプロンプトでこのコマンドを使用すると、現在強調表示されているテキストが書き換えられます。"
                },
                "cephable-summarize-text": {
                    "commands": ["要約する"],
                    "name": "このコマンドの後にプロンプトを指定してテキストを要約します。",
                    "description": "このコマンドを音声コントロールとともに使用し、その後にプロンプトを入力して、現在強調表示されているテキストを要約します。"
                },
                "cephable-translate-text": {
                    "commands": ["翻訳する"],
                    "name": "このコマンドの後にプロンプトを入力してテキストを翻訳します。",
                    "description": "音声コントロールに続いてプロンプトでこのコマンドを使用すると、現在強調表示されているテキストが翻訳されます。"
                },
                "cephable-click-by-name": {
                    "commands": ["タップ", "打つ", "移動", "行く"],
                    "name": "名前で要素をタップ",
                    "description": "ページ上の何かの名前をタップします。たとえば、「保存をタップ」すると、「保存」というボタンがクリックされます。"
                }
            },
            "description": "デバイスコントロールは、使用している特定のデバイスまたは接続に関連付けられています。アプリのコントロールに追加しなくても利用でき、特定のデバイスでのみサポートされている機能やイベントに特に役立ちます。"
        },
        "warn": "マイクが起動されていません。グローバル コントロールとデバイス コントロールを使用するには、マイクを起動する必要があります。",
        "changeProfile": {
            "success": "アプリのコントロールを変更: {{value}}",
            "error": "アプリコントロールが見つかりません: '{{value}}'"
        },
        "descriptionShort": "グローバルコントロールとデバイスコントロールは、あらゆるソフトウェアで動作するように設計された、いつでも利用可能なアクションです。「カメラを停止」などのグローバルコントロールはシステム全体に適用され、アプリに依存しません。一方、デバイスコントロールは各デバイス接続に合わせてカスタマイズされ、標準のアプリコントロールよりも高度な機能を使用できます。",
        "description": "グローバルコントロールとデバイスコントロールは、あらゆるソフトウェアで動作するように設計された、いつでも利用可能なアクションです。「カメラを停止」などのグローバルコントロールはシステム全体に適用され、アプリに依存しません。一方、デバイスコントロールは各デバイスの接続に合わせてカスタマイズされ、標準的なアプリコントロールよりも高度な機能を使用できます。これらのコントロールは現在、音声コントロールとしてアクセスされていますが、将来的には他の入力にも対応する予定です。"
    },
    "notifications": {
        "title": "通知",
        "center": "通知センター",
        "empty": "現時点では通知はありません。しばらくしてからもう一度ご確認ください。",
        "seen": "見た",
        "markAsRead": "既読にする",
        "view": "すべての {{value}} 件の通知を表示"
    },
    "unsaved": {
        "title": "保存されていない変更があります。",
        "description": "変更が保存されていません。このページを離れますか?",
        "cancel": "保存せずに終了",
        "confirm": "保存して終了"
    },
    "login": {
        "welcome": "Cephable へようこそ!",
        "subtitle": "<strong>あなたの</strong>条件に合わせてテクノロジーをコントロールします。",
        "create": "アカウントを作成する",
        "signIn": "サインイン",
        "loading": "サインインにリダイレクトしています...",
        "error": "サインイン中にエラーが発生しました。もう一度サインインしてください。",
        "existingAccount": "すでにアカウントをお持ちですか?",
        "description": "Cephableで、パソコン、アプリ、ゲームを自在にコントロール。素早い操作、音声コマンド、表情、ジェスチャー、傾きなどを自在に操るパーソナルAI。クラウド処理は一切不要。あなたと一緒に動き、シームレスにコントロールします。"
    },
    "home": {
        "title": "家",
        "startControls": "電源を入れてください！",
        "manage": "設定",
        "profileGenerate": {
            "title": "おっと。まだアプリコントロールがないようです。",
            "description": "Cephable がコンピュータを制御するには、何を制御したいのかを知る必要があります。アプリのコントロールを最初から作成することも、コントロール ジェネレーターを使用して作成することもできます。"
        }
    },
    "wizard": {
        "description": "Cephable はこの情報を使用して、確認して試すためのコントロールを生成します。",
        "includeDefaultKeysQuestion": "キーとマウスのクリックに対するデフォルトの音声コマンドを含めますか?",
        "placeholderAppName": "Microsoft Word、Minecraft、YouTube、コードなど。",
        "noOptionsText": "制御したいアプリを見つけるために入力を始めます",
        "generate": "コントロールを生成する",
        "complete": {
            "title": "はい、終わりました！",
            "description": "生成されたコントロールを表示するには、下のボタンをクリックしてください。 手動で編集、追加、または削除して、自分にとって完璧なものにすることができます。",
            "viewControls": "コントロールを見る"
        },
        "error": {
            "emptyInput": "少なくとも1つの入力方法を選択してください",
            "emptyApp": "少なくとも 1 つのアプリ名を入力してください",
            "generatingProfile": "アプリコントロールの生成中にエラーが発生しました"
        },
        "loading": {
            "title": "私たちはすべてのピースをまとめています",
            "description": "これには約 1 分ほどかかる場合があります。このページを離れたり戻ったりしないでください。そうしないと生成が停止します。"
        },
        "selectedTips": {
            "title": "ヒント #{{count}}",
            "previous": "前のヒント",
            "next": "次のヒント",
            "two": "メイン パネルの「表現制御設定」セクションで、入力の感度を制御できます。これにより、Cephable が特定の入力を解釈する方法をさらに細かく調整できます。また、Cephable はユーザーと連携して時間の経過とともに改善されます。",
            "three": "これを設定した後も、構成を完全に制御できます。ベースラインを提供しますが、いつでも、自分の操作とコンピューター上での動作のマッピングを変更できます。",
            "four": "Cephable を使用するときは、コントロールを印刷して物理的なコピーを用意することができます。これはまったく新しいことなので、慣れるまでに少し時間がかかることは承知しています。練習すれば上達します!",
            "one": "Cephableを使って、あるデバイスから別のデバイスを操作できることをご存知ですか？モバイル、タブレット、あるいは別のコンピューターにCephableをダウンロードし、操作したい接続（この接続も可）を選択してください。個人設定と入力プロファイルは、すべてのデバイスで共通です！デバイスと接続でCephableが動作していることを確認してください。"
        },
        "steps": {
            "one": "ステップ 1. 制御するアプリの名前を入力します。",
            "two": "ステップ 2. 使用する入力コントロールを確認します。",
            "three": "ステップ3.（オプション）",
            "threeContinued": "よく使用するコマンドや特に好んで使用するコマンドに設定したい特定のアクションについて説明してください。以下のようなわかりやすい英語を使用してください。"
        },
        "title": "アプリコントロールを生成する",
        "titleLong": "アプリコントロールを生成する",
        "try": "コントロールジェネレータを試す",
        "placeholder": "音声コマンドは短くしてください。\n\nプレゼンテーションの次のスライドに進むには、「進む」と言えばいいと思います。\n\nカーソルの移動には頭の動きを、編集のショートカットには音声コントロールを使いたいです。\n\nキャラクターの動きや能力すべてにクイックアクションボタンを追加してください。"
    },
    "macros": {
        "title": "コントロール",
        "titlePlural": "コントロール",
        "description": "コントロールには、入力 (頭を傾けるなどのアクション) と、その入力アクションが記録された後に Cephable が実行する手順が含まれます。コントロールを使用すると、単一の入力によってトリガーされる手順の組み合わせを作成できます。",
        "new": "新しいコントロールを作成する",
        "newDescription": "複数のステップと入力を組み合わせるための新しいコントロールを作成します。",
        "add": "コントロールを追加",
        "create": "コントロールを作成する",
        "name": {
            "title": "コントロール名",
            "question": "このコントロールに何という名前を付けますか?",
            "description": "後で簡単に見つけられるように、コントロールに名前を付けます。",
            "placeholder": "このコントロールが「ジャンプ」や「ズームイン」などのアクションを実行している"
        },
        "empty": "まだコントロールがありません。以下をクリックしてコントロールを作成してください。",
        "copySuffix": "{{name}}_コピー"
    },
    "event": {
        "title": "ステップ",
        "titlePlural": "手順",
        "previewSummaryPlural": "{{first}} および {{total}} 件の他のイベント",
        "add": "ステップを追加",
        "stepType": "ステップタイプ",
        "select": "追加するステップのタイプを選択します。",
        "question": "Cephable にどのような種類のアクションを実行させたいですか?",
        "setup": "ステップを設定する",
        "description": "ステップは、入力がトリガーされた後に Cephable が実行するアクションです。コントロールに複数のステップを追加して、アクションの組み合わせを作成できます。",
        "expand": "展開して残りの手順を確認してください",
        "stepUp": "ステップアップ",
        "stepDown": "ステップダウン",
        "stepCopy": "コピーステップ",
        "stepRemove": "ステップを削除",
        "insertStep": "以下に手順を挿入",
        "showOptions": "オプションを表示",
        "hideOptions": "オプションを非表示",
        "hold": "ホールド時間（ミリ秒）",
        "error": "ステップを構成する必要があります。",
        "multiple": "複数のステップ",
        "deviceTypeCustomAction": {
            "title": "カスタムデバイスアクション"
        },
        "keyPress": {
            "title": "キーまたはボタンを押してください",
            "short": "プレス",
            "fieldSet": "押すキーまたはボタン",
            "label": "キーまたはボタン",
            "holdTime": "キーを押し続ける時間（ミリ秒）",
            "description": "キーボードを使わずにキーボードのキーを押します。",
            "longDescription": "この機能は、キーボードのキーを押す動作をシミュレートします。たとえば、物理的なキーを押すのが難しい場合は、音声コマンドまたは別の入力方法を使用して、仮想的にキーを「押す」ことができます。",
            "example": "「Enter」と言えば、Enter キーを物理的に押さずに電子メールを送信できます。",
            "timing": "キーを押すタイミング",
            "tap": "タップ",
            "tapLong": "タップボタン",
            "latch": "ラッチ",
            "latchLong": "解放されるまで保持する",
            "hold": "所有",
            "holdLong": "一定時間保持する",
            "latchLabel": "解放されるまで<strong>{{value}}</strong>を保持します",
            "tapLabel": "<strong>{{value}}</strong>をタップ",
            "pressLabel": "<strong>{{value}}</strong>を<strong>{{time}}</strong>ミリ秒間押します",
            "remove": "キーの押下を解除",
            "add": "押すキー/ボタンを追加"
        },
        "keyRelease": {
            "title": "キーまたはボタンを離す",
            "short": "リリース",
            "selected": "リリースするキーを選択",
            "description": "押したままにしていたキーボードのキーを放します。",
            "longDescription": "この機能は、キーボードのキーを放す動作をシミュレートします。キーを無期限に押し続ける操作と組み合わせて使用する必要があります。たとえば、物理的なキーを押すのが難しい場合は、音声コマンドまたは別の入力方法を使用して、仮想的にキーを「放す」ことができます。",
            "example": "実行を停止するには、「Toggle Run」と言った後に「Stop」と言います。",
            "label": "<strong>{{value}}</strong>をリリース",
            "add": "リリースにキー/ボタンを追加",
            "remove": "キーリリースを削除する"
        },
        "keyToggle": {
            "title": "トグルキーまたはボタン",
            "short": "トグル",
            "selected": "切り替えるキーを選択",
            "description": "単一のコントロールで、照明スイッチのようにキーボードのキーをオンまたはオフにします。",
            "longDescription": "これは、スイッチのように、キーの機能をオンまたはオフにします。これは、キーを不定の時間押したままにしておく場合に便利です。これを使用すると、キーの押下とキーのリリースまたは停止の両方に対して同じアクションを維持できます。",
            "example": "走り始めるには「Toggle Run」と言います。走りを止めるには「Toggle Run」と言います。",
            "label": "<strong>{{value}}</strong>を切り替える",
            "add": "トグルにキー/ボタンを追加",
            "remove": "キートグルの削除"
        },
        "pause": {
            "title": "一時停止",
            "description": "アクション間に短い遅延を追加します。",
            "longDescription": "この機能を使用すると、アクション間に短い遅延を挿入できます。これは、次のアクションを開始する前に 1 つのアクションを完全に完了する必要がある状況では不可欠です。たとえば、ドキュメント内のテキストを太字にするコマンドを使用している場合は、最初にコンテキスト メニューを開く必要がある場合があります。一時停止機能を使用すると、次の手順に進む前にコンテキスト メニューが開いてアクティブになるまでの十分な時間を確保できるため、スムーズでエラーのない操作が保証されます。",
            "example": "音声コマンドを使用してドキュメントを編集しているとします。「テキストの書式設定」と言うと、コンテキスト メニューが開きます。次に、メニューが完全に表示されるまで少し待ってから、「太字」と言うと、選択したテキストに太字の書式が適用されます。一時停止機能により、コンテキスト メニューが次のコマンドを受け付ける準備が整います。",
            "label": "<strong>{{value}}</strong>ミリ秒間一時停止します"
        },
        "type": {
            "title": "タイプ",
            "field": "入力するフレーズ",
            "placeholder": "入力したフレーズ",
            "question": "どのようなテキストを入力しますか?",
            "description": "キーボードを使用するのと同じようにテキストを入力します。",
            "longDescription": "これは、キーボードでの入力と同様に、テキスト文字列の入力を模倣します。各キーを押さずに長いテキストを入力するのに最適です。テキストを動的に入力する場合は、代わりにディクテーション機能を使用できます。",
            "example": "「名前」と言うと、チャット ウィンドウに「こんにちは、私の名前は Ellen Ripley です。」と入力できます。",
            "label": "<strong>{{value}}</strong>と入力"
        },
        "mouseMove": {
            "title": "マウスを動かす",
            "description": "画面上でポインターを移動します。",
            "longDescription": "物理的なマウスを使わずに、画面のカーソルやポインターを移動します。これは、手の可動性が限られているユーザーにとって特に便利です。これは、一部のゲームで必要なマウスの動きの細かい制御に役立ちます。頭の動きを使用してすべてのマウスの動きをシミュレートする場合は、カメラ設定で「マウス制御のための頭の動き」を試すことができます。",
            "example": "「マウスを右に移動」と言うと、カーソルが 100 ピクセル右に移動します。",
            "moveX": "マウスを左/右にピクセル移動",
            "numberMoveX": "左/右に移動するピクセル数",
            "moveY": "マウスを上下にピクセル移動",
            "numberMoveY": "上/下に移動するピクセル数",
            "label": "マウスを<strong>{{value}}</strong>回動かす",
            "command": "マウスの移動: {{command}}"
        },
        "joystickMove": {
            "title": "ジョイスティックを動かす",
            "description": "ジョイスティックを使用して画面上のものを移動します。",
            "longDescription": "この機能は、ジョイスティックの動きをシミュレートします。たとえば、物理的なジョイスティックの使用が難しい場合は、音声コマンドまたは別の入力方法を使用して、ジョイスティックを仮想的に動かすことができます。",
            "example": "「ジョイスティックを左に動かして」と言うと、ジョイスティックが 100 ピクセル左に移動します。",
            "prefix": "左ジョイスティックを動かす",
            "left": "左ジョイスティック",
            "leftX": "左X",
            "leftY": "左Y",
            "right": "右ジョイスティック",
            "rightX": "右X",
            "rightY": "右Y",
            "x": "X軸の強度",
            "y": "Y軸の強度",
            "moveXLabel": "X に移動: {{value}}",
            "moveYLabel": "Y 方向に移動: {{value}}",
            "labelLeft": "左ジョイスティックを動かす",
            "labelRight": "右ジョイスティックを動かす",
            "latch": "ラッチは、「すべて停止」コマンドを使用して解放されるまで位置を保持します。"
        },
        "playAudio": {
            "title": "オーディオを再生",
            "placeholder": "Cephableが言うであろう発言のフレーズ",
            "description": "音、単語、またはフレーズを再生します。",
            "longDescription": "この機能により、ユーザーは入力したフレーズを音声に変換できます。これは、話すことが困難な人にとって特に便利です。フレーズを入力すると、PlayAudio 機能により合成音声を使用してテキストが読み上げられます。これは、コミュニケーションや、ユーザーが口頭で情報を伝える必要があるが自分の声を使用する代わりに別の方法を好む、または必要とする状況に役立ちます。",
            "example": "笑顔で「Hello」という言葉を演奏します。",
            "label": "<strong>\"{{value}}\"</strong>と発音する"
        },
        "stopOutputs": {
            "title": "すべての出力を停止",
            "titleLong": "すべての出力を停止します（すべてのキーとボタンを放し、すべてのマウスの動きを停止し、すべての入力を停止します）",
            "description": "キーの押下など、進行中のすべてのアクションを停止します。",
            "longDescription": "進行中の出力またはアクションをすべて直ちに停止します。これは、プロセスを停止するための安全機能または利便性機能です。カメラまたはマイクのコントロールを閉じるか一時停止すると、自動的に実行されます。",
            "example": "すべての出力を停止するには、「停止」と言います。",
            "label": "すべての出力を停止し、キーを放します"
        },
        "custom": {
            "title": "カスタム"
        },
        "options": {
            "moveUp": "上へ移動",
            "moveDown": "下に移動",
            "moveLeft": "左に移動",
            "moveRight": "右に移動",
            "copyStep": "コピーステップ",
            "removeStep": "ステップを削除"
        },
        "directions": {
            "up": "上",
            "down": "下",
            "left": "左",
            "right": "右"
        }
    },
    "expression": {
        "title": "表情",
        "titlePlural": "表情",
        "label": "表情・身振り",
        "start": "式コントロールの開始",
        "startSmiling": {
            "title": "笑顔を始めましょう",
            "description": "最初は笑っていなかったのに、その後笑顔になると、このコントロールがトリガーされます。注意: このコントロールを、口の開閉コントロールと同じアプリ コントロールで使用すると、競合が発生する可能性があります。"
        },
        "stopSmiling": {
            "title": "笑うのをやめて",
            "description": "笑っていて、その後笑顔をやめると、このコントロールがトリガーされます。注意: このコントロールを、口の開閉コントロールと同じアプリ コントロールで使用すると、競合が発生する可能性があります。"
        },
        "eyebrows": {
            "title": "眉を上げる",
            "description": "両方の眉毛を基本の休息位置から上げると、このコントロールがトリガーされます。"
        },
        "openMouth": {
            "title": "口を開ける",
            "description": "口が閉じている場合（またはベースラインがわずかに開いている場合）、さらに口を開けると、このコントロールがトリガーされます。注意: このコントロールをスマイル コントロールと同じアプリ コントロールで使用すると、競合が発生する可能性があります。"
        },
        "closeMouth": {
            "title": "口を閉じる",
            "description": "口が開いている状態で完全に閉じると、このコントロールがトリガーされます。注意: このコントロールをスマイル コントロールと同じアプリ コントロールで使用すると、競合が発生する可能性があります。"
        },
        "description": "表情でデジタル体験をワンランクアップ。眉を上げる、笑顔を作る、その他のジェスチャーを使って、マウスポインターをシームレスに操作したり、アクションを実行したり、インタラクションをカスタマイズしたりできます。"
    },
    "head": {
        "title": "頭の動き",
        "titlePlural": "頭の動き",
        "label": "頭/体の動き",
        "question": "どのような種類の動きを使いたいですか?",
        "tilt": {
            "title": "頭を傾ける",
            "left": {
                "title": "頭を左に傾ける",
                "description": "カメラを見て頭を左に傾けると、このコントロールがトリガーされます。"
            },
            "right": {
                "title": "頭を右に傾ける",
                "description": "カメラを見て頭を右に傾けると、このコントロールがトリガーされます。"
            },
            "back": {
                "title": "頭を後ろに傾ける",
                "description": "カメラを見て、頭を後ろに傾けて上を見上げると、このコントロールがトリガーされます。"
            },
            "forward": {
                "title": "頭を前に傾ける",
                "description": "カメラを見て、頭を前に傾けて下を向くと、このコントロールがトリガーされます。"
            },
            "description": "頭を左または右に傾けると、コントロールやマウスのナビゲーションが強化されます。"
        },
        "turn": {
            "title": "ヘッドターン",
            "left": {
                "title": "頭を左に向ける",
                "description": "カメラを見て頭を回して左を向くと、このコントロールがトリガーされます。"
            },
            "right": {
                "title": "頭を右に向ける",
                "description": "カメラを見て頭を回して右を向くと、このコントロールがトリガーされます。"
            },
            "description": "コントロールやマウスのナビゲーションを強化するには、頭を左または右に回します。"
        },
        "lean": {
            "title": "ヘッドリーン",
            "left": {
                "title": "頭を左に傾ける",
                "description": "カメラを見て左に傾き、顔がカメラ フレーム内でさらに左に来るようにすると、このコントロールがトリガーされます。"
            },
            "right": {
                "title": "頭を右に傾ける",
                "description": "カメラを見て右に傾き、顔がカメラ フレーム内でさらに右側に来るようにすると、このコントロールがトリガーされます。"
            },
            "back": {
                "title": "頭を後ろに傾ける",
                "description": "カメラを見つめているときに、後ろに傾いて顔がカメラから遠ざかると、このコントロールがトリガーされます。"
            },
            "forward": {
                "title": "頭を前に傾ける",
                "description": "カメラを見て、顔をカメラに近づけるために前に傾くと、このコントロールがトリガーされます。"
            },
            "up": {
                "title": "ボディを上に移動",
                "description": "カメラを見ながら、首を伸ばしたり、体全体を上に動かしたりして頭を上げると、このコントロールがトリガーされます。"
            },
            "down": {
                "title": "本文を下に移動",
                "description": "カメラを見ながら、首をすくめたり、しゃがんだり、体全体を下げたりして頭を下げると、このコントロールがトリガーされます。"
            },
            "center": {
                "title": "頭を集中させる",
                "description": "カメラを見て、頭をベースラインに一致する中心位置に戻すと、このコントロールがトリガーされます。"
            },
            "description": "頭を左または右に傾けると、コントロールやマウス操作が強化されます。"
        },
        "description": "頭を傾ける、うなずく、回すといった動きで、デバイスや接続を操作できます。Cephableはデバイスのカメラを使用することで、プライバシーを守りながら直感的な操作性を実現し、高度な操作やマウス操作を実現します。"
    },
    "voice": {
        "title": "音声コントロール",
        "titlePlural": "音声コントロール",
        "placeholder": "Cephableが聞き取る音声またはフレーズ",
        "question": "このコントロールに対してどのようなステートメントまたはフレーズを伝えたいですか?",
        "when": "私が言うと...",
        "say": "「{{value}}」と発音する",
        "load": {
            "fail": {
                "title": "{{language}} 音声コントロールは利用できません",
                "description": "ああ、大変！音声コントロール用の {{language}} を読み込めませんでした。インターネット接続を確認して、もう一度お試しください。接続が回復するまで英語 (米国) を使用します。"
            }
        },
        "description": "マイクを起動すると、インテリジェントで自然な音声コマンドが使用可能になり、ユーザーはアプリケーションやソフトウェアを問わず、コンピューターをシームレスに操作できるようになります。自然な発声でコマンドを実行したり、テキストを音声入力したりすることで、簡単かつ直感的な操作を実現します。"
    },
    "motion": {
        "title": "モーションコントロール",
        "titlePlural": "モーションコントロール",
        "question": "携帯電話やタブレットでどのような種類のモーションを使用したいですか?",
        "start": "モーションコントロールを開始",
        "settings": "モーション設定",
        "descriptionShort": "デバイスを傾けたり、回したり、振ったりして Cephable を制御します。",
        "description": "モーション コントロールを使用すると、コンパニオン アプリでのスマートフォンやタブレットの動きをデバイスのコントロールに変換できます。スマートフォンをさまざまな方向に傾けたり振ったりして、新しい出力を作成します。",
        "up": {
            "title": "デバイスを上に傾ける",
            "description": "デバイスが平らな面に置かれ、自分の方を向くように傾けると、このコントロールが起動します。"
        },
        "down": {
            "title": "デバイスを下に傾ける",
            "description": "デバイスが平らな面に置かれ、自分から遠ざかるように下に傾けると、このコントロールが起動します。"
        },
        "left": {
            "title": "デバイスを左に傾ける",
            "description": "デバイスが平らな面に置かれ、左に傾けて左を向くと、このコントロールがトリガーされます。"
        },
        "right": {
            "title": "デバイスを右に傾ける",
            "description": "デバイスが平らな面に置かれ、右に傾けて右を向くと、このコントロールがトリガーされます。"
        },
        "shake": {
            "title": "デバイスを振る",
            "description": "デバイスを振ると、このコントロールが起動します。"
        },
        "edit": {
            "title": "モーション設定を編集",
            "description": "モーションコントロール設定を変更して、コンパニオンアプリでランニング中に携帯電話をどれだけ動かす必要があるかを調整します。",
            "sensitivity": {
                "title": "モーションコントロールの感度設定",
                "description": "感度は、コントロールをトリガーするためにデバイスをどの程度傾ける必要があるかを Cephable に伝えます。値が大きいほど (スライダーの右端)、感度が高くなり、コントロールをトリガーするために傾ける必要が少なくなります。"
            },
            "tilt": {
                "title": "傾き感度",
                "description": "これらの値は、入力が認識されるためにデバイスを上下左右にどの程度傾ける必要があるかを決定します。"
            },
            "mouse": {
                "title": "マウス移動のモーションコントロール",
                "description": "マウスを動かすためにコントロールをトリガーするのではなく、モーションコントロールを使用するかどうか、またどのように使用するかを決定します。",
                "enable": {
                    "title": "マウス移動のモーションコントロールを有効にする",
                    "description": "これをオンにすると、トリガー コントロールの代わりに、一部のモーション コントロールがマウスの移動に使用されます。",
                    "option": "マウスの移動にモーションコントロールを使用しますか?"
                },
                "invert": {
                    "title": "マウスの動きを反転",
                    "description": "X 軸の場合: これがオンになっている場合、マウスを左に動かすと右に移動し、右に動かすと左に移動します。Y 軸の場合: これがオンになっている場合、マウスを下に動かすと上に移動し、上に動かすと下に移動します。",
                    "x": "X軸のマウスの動きを反転しますか?",
                    "y": "Y軸のマウスの動きを反転しますか?"
                }
            }
        }
    },
    "keys": {
        "title": "キーまたはボタン",
        "titlePlural": "キーまたはボタン",
        "label": "外部キー/ボタン",
        "question": "どのキーまたはボタンを押しますか?",
        "edit": "キーとボタンを編集する",
        "defaultOption": "キーとマウスのクリックに対するデフォルトの音声コマンドを含めますか?",
        "description": "キーとボタンを使用すると、さまざまな入力コントロールをキーボードとコントローラーのボタンの押下にマッピングできます。",
        "then": "Cephable は... を押します。",
        "empty": "この条件に一致するキーコントロールはありません。",
        "backspace": "バックスペース",
        "delete": "消去",
        "enter": "入力",
        "space": "スペースバー",
        "tab": "タブ",
        "shift": "シフト",
        "ctrl": "Ctrl",
        "leftCtrl": "左Ctrl",
        "rightCtrl": "右Ctrl",
        "leftShift": "左シフト",
        "rightShift": "右シフト",
        "alt": "全て",
        "leftAlt": "左Alt",
        "escape": "逃げる",
        "up": "上矢印",
        "down": "下矢印",
        "left": "左矢印",
        "right": "右矢印",
        "command": "指示",
        "caps": "キャップスロック"
    },
    "talkback": {
        "title": "トークバック",
        "question": "Cephable に何を言ってもらいたいですか?",
        "description": "Cephable に話しかけるためのコントロールを設定します。話しかけたいさまざまなフレーズにコントロールを割り当てることができます。",
        "thenMacro": "すると、Cephable はこう言います...",
        "empty": "この条件に一致するトークバック コントロールはありません。",
        "add": "新しいトークバックコントロールを追加する",
        "remove": "トークバックコントロールを削除",
        "edit": "トークバックコントロールを編集する",
        "deprecatedNotice": "Talkback は、主要なアプリ コントロールに直接統合されました。アプリ コントロールには、更新が必要な古い Talkback イベントがいくつかあります。"
    },
    "dictation": {
        "title": "ディクテーション",
        "question": "ディクテーション モードをトリガーするフレーズは何ですか?",
        "thenMacro": "Cephable は...",
        "empty": "この条件に一致するディクテーション コントロールはありません。",
        "type": "タイプ",
        "edit": "ディクテーションフレーズを編集する",
        "remove": "ディクテーションフレーズを削除",
        "add": "新しいディクテーションフレーズを追加する",
        "on": "ディクテーション",
        "off": "コマンド",
        "onboarding": {
            "tourLabel": "ディクテーション",
            "learn": "ディクテーション モードを使用して、ハンズフリーで音声をテキストに変換する方法を学びます。",
            "welcome": {
                "title": "ディクテーション",
                "description": "ディクテーションを使えば、自然な話し方で、話しながら入力できます。まるで、あなたの話す言葉をすべて入力してくれるパーソナルアシスタントがいるかのようです。"
            },
            "microphone": {
                "title": "マイクをオンにする",
                "description": "まず、マイクをオンにします。Cephableパネルのマイク切り替えボタンをクリックします。"
            },
            "activate": {
                "title": "ディクテーションモードを開始",
                "description": "音声はコマンドモードで起動します。ディクテーションを開始するには、「ディクテーションを開始」と言うか、ディクテーションボタンをクリックしてください。それでは、ディクテーションモードをオンにしましょう。"
            },
            "speaking": {
                "title": "ドキュメントまたはフィールドをクリックして読み上げを開始します",
                "description": "ディクテーションは、話した内容をリアルタイムで入力します。テキストフィールドまたはドキュメントをクリックして、読み上げを開始してください。例えば、「ディクテーションモードの使い方は次のとおりです」と発声します。"
            },
            "pauseResume": {
                "title": "ディクテーションの一時停止",
                "description": "ディクテーションを停止せずに休憩したい場合は、「ディクテーションを一時停止」と発声してください。「ディクテーションを開始」と発声すればいつでも再開できます。この機能は、常時オンのグローバルコントロールとデバイスコントロールでさらにカスタマイズできます。"
            },
            "stop": {
                "title": "ディクテーションをやめる",
                "description": "アプリのコントロールに戻りたいですか？「ディクテーションを停止」と言うだけです。これでディクテーションモードが停止し、コマンドモードに戻ります。「ディクテーションを開始」と言えばいつでも再開できます。"
            },
            "complete": {
                "title": "おめでとうございます！",
                "description": "これで完了です！音声入力、一時停止、再開、そして音声入力モードとコマンドモードの切り替えができるようになりました。音声入力はハンズフリー入力を可能にする強力なツールです。メールや文書の作成など、音声入力が必要なあらゆる作業にお使いいただけます。"
            }
        },
        "description": "ディクテーションを使えば、自然に話しながら、話しながら入力できます。まるで、あなたの話す言葉をすべて入力してくれるパーソナルアシスタントがいるかのようです。"
    },
    "face": {
        "title": "表情",
        "titlePlural": "表情",
        "try": "表情コントロールを試す",
        "question": "どのような表情を使いたいですか?",
        "descriptionShort": "さまざまな顔の動きを使用して、コントロールを強化します。",
        "description": "表情は表情コントロールの一部です。表情を様々な動きでコントロールできます。眉毛や口の動きなど、様々な表情を作り出すことができます。"
    },
    "other": {
        "title": "他の",
        "titlePlural": "その他のコントロール",
        "label": "その他のコントロール",
        "placeholder": "その他の実験コマンド",
        "question": "どのような追加コマンドを使用しますか？これらは通常、他のカテゴリに当てはまらないCephable以外の接続で使用されます。また、指定された単語またはフレーズを話すと、音声コマンドとして機能する場合もあります。注：これらのコントロールは試験段階であり、完全にサポートされていない可能性があります。",
        "description": "その他のコントロールは試験段階であり、完全にはサポートされていない可能性があります。Cephable以外の接続、または指定された単語やフレーズを話す際の音声コマンドとして使用できます。"
    },
    "support": {
        "title": "サポート",
        "profiles": "アプリコントロールの概要",
        "question": "まだ必要なものが見つかりませんか?",
        "more": "Cephable.com でステップバイステップのガイド、チュートリアル、ビデオなどの詳細をご覧ください。"
    },
    "community": {
        "title": "コミュニティに参加する",
        "description": "サポートを受けたり、アイデアを共有したり、Cephable のコミュニティのメンバーになったりできます。",
        "discord": "Discordコミュニティ",
        "facebook": "Facebookグループ"
    },
    "resources": {
        "title": "役立つリソース",
        "description": "Cephable の特徴と機能に関する質問への回答を見つけます。",
        "guides": "ステップバイステップガイド"
    },
    "feedback": {
        "title": "フィードバック",
        "description": "Cephable の使用経験について教えてください。",
        "contact": "お問い合わせ",
        "feature": "機能を提案する",
        "bug": "問題を報告する"
    },
    "settings": {
        "title": "設定",
        "orgTitle": "{{ value }} 設定",
        "general": "一般的なアプリ設定",
        "description": "これは、コントロールを微調整してエクスペリエンスをカスタマイズするためのキャンバスです。"
    },
    "account": {
        "title": "アカウント",
        "menu": "ユーザーメニュー",
        "settings": "アカウント設定",
        "description": "Cephable との接続を維持するには、重要な情報を更新してください。",
        "usernameLabel": "ユーザー名:",
        "emailLabel": "メールアドレス:",
        "password": {
            "change": "パスワードを変更する",
            "description": "アカウントを安全に保つためにパスワードを更新してください。",
            "old": "以前のパスワード",
            "current": "現在のパスワード",
            "new": "新しいパスワード",
            "desired": "希望する新しいパスワード",
            "confirm": "新しいパスワードの確認",
            "update": "パスワードを更新"
        },
        "isEmailVerified": {
            "title": "電子メールは確認されていません。",
            "description": "あなたのメールは確認されていません。確認リンクが記載されたメールを確認してください。",
            "resend": "メールを再送信",
            "success": "新しい確認メールを送信しました。",
            "error": "確認メールの送信中にエラーが発生しました。しばらくしてからもう一度お試しください。",
            "org": "メールアドレスの確認がまだ完了していません。ライセンスの詳細にアクセスするにはメールアドレスが必要です。確認リンクが記載されたメールをご確認ください。",
            "titleAlt": "メールアドレスを確認してください",
            "descriptionLong": "Cephableへようこそ！{{email}}に確認メールを送信しました。受信トレイまたは迷惑メールフォルダをご確認の上、リンクをクリックしてください。メールが見つからない場合は、確認メールを再送信できます。",
            "appBlock": "もうすぐ完了です！確認メールを{{email}}に送信しました。受信トレイをご確認の上、リンクをクリックしてメールアドレスをご確認ください。メールが見つからない場合は、迷惑メールフォルダをご確認ください。"
        },
        "signout": {
            "title": "サインアウト",
            "question": "本当にサインアウトしますか?",
            "confirm": "はい、サインアウトします",
            "warn": {
                "title": "ログアウトされます。",
                "description": "しばらく操作が行われていないようです。セキュリティ上の理由から、XX 秒後にログアウトします。ログインしたままにしたい場合は、下の「ログインしたままにする」をクリックしてください。",
                "confirm": "ログインしたままにする",
                "cancel": "今すぐサインアウト"
            },
            "description": "サインアウトすると、この接続はアカウントから削除され、Companion アプリや他の接続からは表示されなくなります。",
            "confirmDescription": "ログアウトしてこの接続を削除します"
        },
        "marketing": {
            "title": "メール設定",
            "description": "Cephable からの更新情報やニュースを受け取るには、電子メールの設定を更新してください。",
            "marketing": "マーケティングメール",
            "optIn": "Cephable 体験を向上させるためのチュートリアル、ヒント、アップデート、ニュースレターを受け取りたい"
        },
        "error": {
            "save": "アカウント設定の保存中にエラーが発生しました。",
            "password": "パスワードの更新中にエラーが発生しました。",
            "signout": "サインアウト中にエラーが発生しました。",
            "old": "古いパスワードが必要です。",
            "new": "新しいパスワードが必要です。",
            "match": "パスワードが一致しません。",
            "marketing": "電子メール設定の更新中にエラーが発生しました。",
            "userPreferences": "ユーザー設定の保存中にエラーが発生しました。"
        },
        "success": {
            "save": "アカウント設定が保存されました。",
            "password": "パスワードが更新されました。",
            "marketing": "電子メールの設定が更新されました。",
            "userPreferences": "ユーザー設定が更新されました。"
        },
        "userPreferences": {
            "title": "ユーザー設定",
            "description": "設定を更新して、自分に合った Cephable エクスペリエンスを実現してください。",
            "warningOptOut": "アプリコントロールを保存または更新するときに警告を非表示にする",
            "enableTranscribeTask": "Cephableパネルで実験的なファイルトランスクリプタータスクを有効にする",
            "enableClickByName": "Windowsのみ。画面上の何かの名前を「タップ」する機能を試験的に有効にします。例えば、「保存をタップ」すると「保存」というボタンがクリックされます。",
            "enableGamepadSupport": "ローカルドライバーとXboxコントローラーエミュレーションのゲームパッドサポートを有効にする",
            "enableMetrics": "パフォーマンステストのために使用状況メトリクスの出力を有効にします。Cephableパネルからログをダウンロードできるようになります。"
        }
    },
    "license": {
        "trial": {
            "subtitle": "{{count}} 人の同僚を招待して一緒に Cephable を試すことができます。",
            "noUsersSubtitle": "試用版のユーザーは残っていません。ユーザーを追加するには、有料ライセンスにアップグレードしてください。",
            "expired": {
                "user": "無料トライアルは {{date}} に期限切れになります。アップグレードするには、組織の管理者（{{admin}}）にお問い合わせください。",
                "userLong": "Cephable の無料トライアルの有効期限が切れたようです。アップグレードするには、組織の管理者 ({{admin}}) にお問い合わせください。",
                "admin": "無料トライアルは {{date}} に期限切れになります。",
                "adminLong": "Cephable の無料トライアルの有効期限が切れたようです。アプリを引き続き使用するには、ライセンスをアップグレードしてください。"
            },
            "start": "無料トライアルを始める",
            "title": {
                "single": "残り {{days}} 日間の無料トライアル中です",
                "multiple": "{{organization}} は残り {{days}} 日間の無料トライアル中です"
            },
            "upgrade": "アップグレードすると、強化された音声コントロール、AI インテリジェント タスク、多数の事前構築済みアプリ コントロールなどの機能へのアクセスが維持されます。"
        },
        "key": {
            "title": "ライセンスキー",
            "titlePlural": "ライセンスキー",
            "details": "ライセンスキーの詳細",
            "description": "ライセンス キーは、Cephable Professional、Education、または Developer 機能へのアクセスを許可するために使用される一意の識別子です。",
            "assigned": "使用日: {{date}}",
            "expires": "有効期限: {{date}}",
            "assign": "新しい組織にキーを割り当てる",
            "error": "ライセンス キーの読み込み中にエラーが発生しました。",
            "empty": {
                "title": "ライセンス キーが見つかりません。",
                "description": "この条件に一致するライセンス キーがないようです。または、ライセンス キーをまだ購入していません。"
            },
            "product": {
                "title": "購入",
                "titleLong": "ライセンスキーを購入する",
                "description": "ライセンス キーを購入して、Cephable の潜在能力を最大限に引き出してください。利用可能なさまざまなプランと価格オプションをご覧ください。",
                "action": "今すぐ購入",
                "empty": {
                    "title": "商品が見つかりません。",
                    "description": "製品がないようです。この問題を解決するには、弊社の営業チームまたは担当者にお問い合わせください。"
                },
                "yearly": "年払い",
                "years": "{{value}} 年ごとに請求されます",
                "days": "{{value}} 日ごとに請求されます",
                "Subscription": {
                    "title": "サブスクリプション"
                },
                "MeteredConsumption": {
                    "title": "従量制消費"
                },
                "PayDown": {
                    "title": "返済する"
                },
                "OneTime": {
                    "title": "一度"
                }
            }
        },
        "upgrade": {
            "professional": "Cephableプロフェッショナルライセンスへのアップグレード",
            "generic": {
                "title": "Cephableエクスペリエンスをアップグレード",
                "description": "Cephable プラットフォームは、職場や学校での商用利用やネイティブ ソリューションへの統合に適したさまざまな製品を提供します。"
            },
            "fallback": {
                "title": "請求ポータルの読み込み中にエラーが発生しました",
                "description": "請求ポータルを読み込めません。アップグレードを続行するには、下のボタンをクリックして sales@cephable.com にお問い合わせください。"
            }
        },
        "required": {
            "title": "Cephableプロフェッショナルライセンスが必要です",
            "description": "Cephable Basic をご利用のようですが、これは Cephable の商用利用をサポートしていません。アプリを引き続きご利用いただくには、プロフェッショナルライセンスにアップグレードしてください。"
        },
        "activate": {
            "question": "すでにライセンスキーをお持ちですか?",
            "button": "活性化",
            "title": "ライセンスキーを有効化",
            "description": "Cephable をアップグレードするには、ライセンス キーを入力してください。",
            "descriptionLong": "Cephable をアップグレードするには、ライセンス キーを入力してください。ライセンス キーをお持ちでない場合は、無料トライアルを開始するか、ライセンスを購入してください。",
            "fieldLabel": "ライセンスキー",
            "placeholder": "翻訳者",
            "invalid": {
                "key": "無効なキーです。正しいキーを入力したことを確認してください。",
                "empty": {
                    "key": "無効なキーです。値を入力したことを確認してください。",
                    "name": "組織名が無効です。値を入力したことを確認してください。"
                }
            },
            "success": "おめでとうございます。アカウントは {{license}} にアップグレードされました。"
        },
        "welcome": {
            "title": "{{license}} へようこそ。",
            "description": "{{organization}} に正常に参加しました。{{description}}"
        },
        "redirect": {
            "title": "リダイレクト",
            "description": "外部の請求ポータルにリダイレクトされました。ブラウザに新しいタブが開きます。数秒以内にリダイレクトされない場合は、下のボタンをクリックしてください。",
            "error": "請求リダイレクトエラー",
            "external": "リダイレクトされました。ブラウザをご確認ください。"
        },
        "pro": {
            "tag": "プロ",
            "detail": "これはCephable Professionalのみの機能です",
            "requiredDetail": "この機能にはCephable Professionalライセンスが必要です。アカウント設定でアップグレードするか無料トライアルを開始できます。"
        },
        "titlePlural": "ライセンス"
    },
    "appSettings": {
        "description": "これらの設定はこのアプリにのみ適用されます。別のコンピューターまたはモバイル デバイス上の Cephable アプリの設定を変更する場合は、そのアプリで設定を編集してください。",
        "autostart": {
            "title": "Cephable を自動的に起動する",
            "description": "この設定をオンにすると、デバイスにログインすると Cephable アプリが自動的に起動します。自動音声および表情コントロールも設定している場合は、それらもすぐに起動します。",
            "question": "Cephable アプリを自動起動しますか?"
        },
        "position": {
            "topLeft": "左上",
            "top": "上中央",
            "topRight": "右上",
            "bottom": "下中央",
            "bottomLeft": "左下",
            "bottomRight": "右下",
            "label": "コマンドフィード位置を選択",
            "description": "コマンド フィードを画面上のどこに表示するかを選択します。"
        },
        "micPosition": {
            "title": "マイク入力ウィンドウの位置",
            "description": "音声とディクテーション用のマイク コントロールを画面上のどこに配置するかを選択します。",
            "label": "マイク入力ウィンドウの位置を選択"
        },
        "cameraPosition": {
            "title": "カメラ入力ウィンドウの位置",
            "description": "顔と頭の動きのカメラコントロールを画面上のどこに配置するかを選択します。",
            "label": "カメラ入力ウィンドウの位置を選択"
        },
        "theme": {
            "title": "テーマ",
            "description": "あなたのスタイルに合ったテーマを選択してください。",
            "label": "テーマを選択",
            "light": "ライト",
            "dark": "暗い",
            "system": "OSのシステム設定を使用する"
        },
        "overlay": {
            "title": "コマンドフィード",
            "description": "コマンド フィードには、使用しているさまざまなコントロールと、コンピューターに送信されたコントロールが表示されます。これはクリックスルーですが、常に他のウィンドウよりも手前に表示されます。この設定をオンにすると、Cephable アプリが表示され、常に他のウィンドウやアプリケーションよりも手前に表示されます。",
            "question": "コマンドフィードを表示しますか?"
        },
        "transparent": {
            "title": "コマンドフィードの透明性",
            "description": "テキストの不透明度を決定します。値が低いほど、フィードが透けて見えるようになります。"
        },
        "panelAutoHide": {
            "title": "セファブルパネルの自動非表示",
            "delay": "隠れる前に遅れる",
            "denominator": "秒",
            "time": "{{value}} 秒"
        },
        "title": "一般的なアプリ設定"
    },
    "input": {
        "title": "入力",
        "titlePlural": "入力コントロール",
        "explore": "入力コントロールを調べる",
        "descriptionShort": "Cephable がより良いデジタル エクスペリエンスを実現するために使用するさまざまな入力コントロールを調べてみましょう。",
        "typeLabel": "入力コントロールタイプ",
        "toolTip": "これは{{alt}}を使用します",
        "remove": "入力コントロールを削除",
        "filter": "入力タイプでフィルタリング",
        "select": "入力を選択",
        "question": "どのようなタイプの入力を使用しますか?",
        "add": "入力を追加",
        "addMore": "別の入力を追加する",
        "removeItem": "アイテム {{index}} を削除",
        "item": "アイテム {{index}}: {{label}}",
        "duplicate": "重複したアイテムは許可されません。",
        "maximum": "許可されるアイテムの最大数は {{maxItems}} 個です。",
        "description": "入力コントロールとは、デバイスを操作するための様々な方法を指します。例えば、音声、頭の動き、表情、その他の接続などです。詳しくは、以下の様々な入力コントロールをご覧ください。"
    },
    "time": {
        "soon": "近日公開",
        "now": "今",
        "today": "今日",
        "yesterday": "昨日",
        "minutesAgo": "{{count}} 分前",
        "minutesAgo_plural": "{{count}} 分前",
        "daysAgo": "{{count}}日前",
        "daysAgo_plural": "{{count}}日前",
        "monthsAgo": "{{count}} か月前",
        "monthsAgo_plural": "{{count}}か月前",
        "yearsAgo": "{{count}}年前",
        "yearsAgo_plural": "{{count}}年前",
        "minutesAhead": "{{count}}分後",
        "todayAhead": "今日遅く",
        "tomorrow": "明日",
        "daysAhead": "{{count}}日後",
        "monthsAhead": "{{count}}か月以内",
        "yearsAhead": "{{count}}年"
    },
    "peripherals": {
        "empty": "周辺機器が検出されませんでした",
        "switch": "スイッチ",
        "keyboard": "キーボード",
        "gamepad": "ゲームパッド",
        "companionApp": "コンパニオンアプリ",
        "available": "使用可能",
        "error": "設定を確認してください。"
    },
    "camera": {
        "windowTitle": "セファブルカメラコントロール",
        "title": "カメラ",
        "titlePlural": "カメラ",
        "settings": "カメラ設定",
        "start": "カメラを起動",
        "restart": "カメラを再起動",
        "descriptionShort": "顔の表情や頭の動きを可能にします。",
        "description": "カメラを使用して、顔の表情や体のジェスチャーをさまざまなコントロールとして検出します。",
        "empty": "カメラが見つかりません。",
        "search": "カメラ名で検索",
        "loading": "カメラコントロールを読み込んでいます...",
        "error": "カメラコントロールの読み込み中に予期しないエラーが発生しました。カメラを確認して、もう一度お試しください。",
        "manage": {
            "title": "クリックすると、カメラの詳細を表示および管理できます。",
            "description": ""
        },
        "detected": {
            "face": "顔が検出されました。",
            "noFace": "顔が検出されませんでした。カメラまたは位置を調整してもう一度お試しください。",
            "command": "検出: {{command}}"
        },
        "permission": {
            "title": "カメラの許可が必要です",
            "description": "顔と体のコントロールを使用するには、Cephable にカメラの使用許可を与える必要があります。",
            "button": "権限設定を開く",
            "no": "カメラアクセス不可",
            "help": "Cephable は、表情や頭部のコントロールを使用するためにカメラにアクセスする必要があります。 <strong>[システム設定]</strong> > <strong>[プライバシー]</strong> > <strong>[カメラ]</strong>に移動して、Cephable がカメラにアクセスできるようにします。"
        },
        "controls": {
            "startData": "顔データの記録を開始しました。カメラ ウィンドウでショートカットをもう一度押すと、記録が停止し、ダウンロードされます。",
            "downloadData": "録画を停止しました。データをダウンロードしています",
            "paused": "カメラコントロールを一時停止しました。",
            "pause": "カメラコントロールを一時停止",
            "resume": "カメラコントロールを再開",
            "resumed": "カメラコントロールを再開しました。",
            "linesOn": "フェイスラインをオンにする",
            "linesOff": "フェイスラインを消す",
            "linesToggle": "フェイスラインの描画を切り替える",
            "noDeviceTitle": "Cephable で使用できるカメラが検出されませんでした。",
            "noDeviceDescription": "モバイルアプリと互換性のあるカメラを接続する必要があります。",
            "noDeviceConnectedDescription": "カメラ コントロールはインターフェイスのプレビューとして機能します。ステップは正常に実行されません。コマンドを開始するには、このコンパニオン デバイスを別のデバイスに接続します。",
            "lines": "フェイスライン"
        },
        "switch": {
            "title": "カメラを切り替える",
            "description": "顔と体のコントロールに使用する別のカメラを選択します。",
            "select": "カメラを選択",
            "next": "次のカメラ",
            "nextLong": "次のカメラに切り替える",
            "empty": "他のカメラは見つかりませんでした。",
            "search": "カメラ名で検索"
        },
        "baseline": {
            "title": "ベースライン",
            "description": "ベースラインは、Cephable が動きを判断するために使用する顔と体のデフォルトの位置です。ここでベースラインを更新およびリセットできます。",
            "update": "ベースラインの更新",
            "reset": "ベースラインをリセット",
            "updated": "ベースラインが更新されました",
            "tooltip": "クリックすると、ベースラインが現在の休息位置に更新されます。"
        },
        "edit": {
            "title": "カメラ設定を編集する",
            "description": "カメラを必要とする入力の設定を、ニーズに合わせて調整できます。",
            "autoStart": {
                "title": "カメラを自動的に起動",
                "option": "カメラとヘッド/表情コントロールを自動起動しますか?",
                "description": "この設定をオンにすると、アプリ起動時にコントローラーがカメラを起動し、表情や頭の動きを操作できるようになります。オフの場合は、接続ページで「カメラを起動」ボタンをタップしてください。"
            },
            "head": {
                "title": "頭の動きの感度",
                "description": "感度は、コントロールをトリガーするためにどれだけ移動する必要があるかを Cephable に伝えます。値が大きいほど (スライダーの右端)、感度が高くなり、コントロールをトリガーするために必要な移動が少なくなります。",
                "tilt": {
                    "title": "ヘッドティルト感度",
                    "description": "これらの値は、コントロールをトリガーするために頭を上下左右にどれだけ傾ける必要があるかを決定します。",
                    "up": "上方向傾斜感度",
                    "down": "チルトダウン感度",
                    "left": "左傾斜感度",
                    "right": "右傾き感度",
                    "scaleHigh": "わずかに傾く",
                    "scaleLow": "大きな傾斜"
                },
                "turn": {
                    "title": "ヘッドターン感度",
                    "description": "これらの値は、コントロールをトリガーするために頭を左右にどれだけ回す必要があるかを決定します。",
                    "left": "左折感度",
                    "right": "右折感度",
                    "scaleHigh": "わずかに曲がる",
                    "scaleLow": "大ターン"
                },
                "lean": {
                    "title": "ヘッドリーン感度",
                    "description": "これらの値は、コントロールをトリガーするために頭を前後にどれだけ傾ける必要があるかを決定します。",
                    "forward": "前傾感度",
                    "back": "リーンバック感度",
                    "right": "右傾き感度",
                    "left": "左傾き感度",
                    "scaleHigh": "わずかに傾く",
                    "scaleLow": "ラージリーン"
                },
                "duck": {
                    "title": "ヘッドダック/ライズ感度",
                    "description": "これらの値は、コントロールをトリガーするために頭をどれだけ下げたり上げたりする必要があるかを決定します。",
                    "down": "ダックダウン感度",
                    "up": "ライズアップ感度",
                    "scaleHigh": "わずかな変化",
                    "scaleLow": "大きな変化"
                }
            },
            "face": {
                "title": "表情の敏感さ",
                "description": "感度は、コントロールをトリガーするために必要な表現をどの程度誇張するかを Cephable に伝えます。値が大きいほど (スライダーの右端)、感度が高くなり、コントロールをトリガーするために必要な動きが少なくなります。",
                "eyebrow": {
                    "title": "眉毛の敏感さ",
                    "description": "これらの値は、コントロールをトリガーするために眉毛をどのくらい上げたり下げたりする必要があるかを決定します。",
                    "up": "眉毛の感度を高める",
                    "scaleHigh": "わずかに上げる",
                    "scaleLow": "大幅な値上げ"
                },
                "mouth": {
                    "title": "口の敏感さ",
                    "description": "これらの値は、コントロールをトリガーするために口をどれだけ開いたり閉じたりする必要があるかを決定します。",
                    "open": "口を開けたときの敏感さ",
                    "close": "口を閉じる感覚",
                    "smile": "笑顔の敏感さ",
                    "scaleHigh": "わずかに開いている",
                    "scaleLow": "大きく開く",
                    "closeScaleHigh": "わずかに閉じた",
                    "closeScaleLow": "しっかりと閉じた",
                    "smileScaleHigh": "微笑み",
                    "smileScaleLow": "大きな笑顔"
                }
            },
            "mouse": {
                "title": "マウス操作のための頭の動き",
                "description": "他の出力をトリガーする代わりに、ヘッド移動コントロールを使用してマウスを移動するかどうか、またその場合どのように使用するかを決定します。",
                "enable": {
                    "title": "マウスコントロールのヘッド移動を有効にする",
                    "description": "これをオンにすると、トリガー コントロールの代わりに、ヘッド ムーブメント コントロールの一部がマウスの移動に使用されます。",
                    "option": "マウスの移動にヘッドコントロールを使用しますか?"
                },
                "input": {
                    "title": "マウス入力タイプ",
                    "description": "マウス コントロールに割り当てるヘッド ジェスチャの種類を選択します。たとえば、「頭を傾ける」は、頭を左右に傾けてマウスを左右に動かすことができ、「頭を回す」は、頭を左右に回してマウスを動かすことができ、「頭を傾ける」は、頭を左右に傾けてマウスを動かすことができることを意味します。",
                    "option": "入力タイプを選択",
                    "optionLong": "マウスを制御するために使用するヘッドの動きのタイプを選択します。"
                },
                "invert": {
                    "title": "マウスの動きを反転",
                    "description": "これをオンにすると、頭を動かす方向がマウスを動かす方向と反転します。X 軸の場合: これをオンにすると、左に動かすとマウスは右に移動し、右に動かすと左に移動します。Y 軸の場合: これをオンにすると、下に動かすとマウスは上に移動し、上に動かすと下に移動します。",
                    "x": "X軸のマウスの動きを反転しますか?",
                    "y": "Y軸のマウスの動きを反転しますか?"
                },
                "mode": {
                    "title": "マウス移動モード",
                    "description": "頭の動きに対してカーソルがどのように反応するかを選択します。"
                },
                "speed": {
                    "title": "マウスの速度",
                    "description": "カーソルを移動させたい一定の速度を決定します。",
                    "fast": "速い",
                    "slow": "遅い"
                },
                "linear": {
                    "title": "マウスの直線移動",
                    "description": "これをオンにすると、カーソルは水平または垂直の直線のみに移動するため、斜めにドリフトすることなく特定の方向に簡単に移動できるようになります。",
                    "option": "マウスの直線移動を使用しますか?"
                },
                "accelerationRate": {
                    "title": "マウス加速応答遅延",
                    "description": "マウスの速度が上がるまでにかかるミリ秒数。"
                },
                "accelerationCurve": {
                    "title": "マウス加速曲線",
                    "description": "頭の動きに応じてカーソルの速度が増加する速度を調整します。",
                    "linear": "リニア",
                    "exponential": "指数関数",
                    "sublinear": "サブリニア"
                },
                "maximumSpeed": {
                    "title": "最大マウス速度",
                    "description": "カーソルが 1 秒間に移動できる最大ピクセル数を決定します。"
                },
                "off": {
                    "title": "オフ",
                    "description": "マウスの移動は無効です。"
                },
                "steadyGlide": {
                    "title": "安定した滑空",
                    "description": "頭を特定のポイントを超えて動かすと、カーソルは一定の速度でその方向に連続的に動きます。"
                },
                "speedBoost": {
                    "title": "スピードブースト",
                    "description": "頭を同じ位置に長く保つと、カーソルの動きが速くなります。頭を動かさずに長く保つと、カーソルの加速も速くなります。"
                },
                "dynamicGlide": {
                    "title": "ダイナミックグライド",
                    "description": "カーソルの速度は、頭を動かす距離に応じて増加します。頭を動かす距離が長いほど、カーソルの移動速度が速くなります。"
                },
                "proportionalSpeed": {
                    "title": "比例速度",
                    "description": "カーソルは画面のサイズに比例して鼻先に沿って動きます。"
                },
                "disabled": "この機能は、リモート接続および拡張機能では無効になっています。"
            }
        },
        "stop": "カメラを停止",
        "show": "カメラを表示",
        "hide": "カメラを隠す",
        "warn": "カメラコントロールが開始されていません。顔と体のコントロールを許可するには、カメラを起動してください。",
        "draw": {
            "error": "カメラフィードの読み込み中にエラーが発生しました。カメラを確認してもう一度お試しください。"
        },
        "select": "顔、体、クイックアクション ボタンを使用して強化されたコントロールを行うには、ペアリングするカメラを選択します。"
    },
    "microphone": {
        "windowTitle": "頭で認識できる音声コントロール",
        "title": "マイクロフォン",
        "titlePlural": "マイク",
        "settings": "マイク設定",
        "start": "マイクを開始",
        "stop": "マイクを停止",
        "descriptionShort": "音声コマンドとディクテーションを有効にします。",
        "description": "内蔵マイクを使用して音声コントロールとディクテーションを有効にします。",
        "select": "音声を使用した制御を強化するために、ペアリングするマイクを選択します。",
        "empty": "マイクが見つかりません。",
        "search": "マイク名で検索",
        "manage": {
            "title": "クリックすると、マイクの詳細を表示および管理できます。",
            "description": ""
        },
        "permission": {
            "title": "マイクの許可が必要です",
            "description": "音声コントロールを使用するには、Cephable にマイクの使用許可を与える必要があります。",
            "button": "権限設定を開く",
            "no": "マイクにアクセスできません",
            "help": "音声コントロールを使用するには、Cephable がマイクにアクセスする必要があります。 <strong>[システム設定]</strong> > <strong>[プライバシー]</strong> > <strong>[マイク]</strong>に移動して、Cephable がマイクにアクセスできるようにします。"
        },
        "controls": {
            "loadingDetail": "これには数分かかる場合があります。",
            "pause": "音声コントロールを一時停止",
            "paused": "コントロールを一時停止しました。",
            "resume": "音声コントロールを再開する",
            "dictationPlay": "ディクテーションモードを開始",
            "dictationPause": "ディクテーションモードを停止",
            "prompt": "話し始めると、ここで音声コントロールが表示されます...",
            "dictationPrompt": "話し始めると、話した内容が入力されます...",
            "latency": "高い遅延が検出されました。リソースを過剰に消費している可能性のあるアプリケーションを閉じることを検討してください。",
            "noDeviceConnectedDescription": "マイク コントロールはインターフェイスのプレビューとして機能します。ステップは正常に実行されません。コマンドを開始するには、このコンパニオン デバイスを別のデバイスに接続します。",
            "status": {
                "loadingModel": "音声モデルを読み込んでいます...",
                "thinking": "考え...",
                "paused": "一時停止しました。",
                "dictating": "口述する。",
                "optimistic": "楽観的：",
                "listening": "リスニング：",
                "loadingPhiModel": "テキスト生成モデルを読み込んでいます...",
                "generatingText": "生成中...",
                "preparingPhiModel": "テキスト生成モデルを準備しています...",
                "permission": "マイクの権限を確認しています...",
                "typing": "タイピング..."
            },
            "generatingTextDetail": "アプリを変更するか、「生成を停止」と言って生成を停止します"
        },
        "edit": {
            "title": "マイクの設定を編集する",
            "autoStart": {
                "title": "マイクを自動的に起動する",
                "option": "マイクと音声コントロールを自動起動しますか?",
                "description": "この設定をオンにすると、入力デバイスを接続するか電源を入れると、起動時にマイクがオンになり、音声コントロールの処理が開始されます。オフになっている場合は、接続ページで「聞き取り開始」ボタンをタップしてください。"
            },
            "optimistic": {
                "title": "楽観的な音声コントロール",
                "option": "楽観的な音声コントロールを使用しますか?",
                "description": "Cephable には、音声コントロール用の 2 つの異なる感度モード (標準と楽観) があります。標準モードでは、Cephable は理解できるすべての単語を認識でき、ディクテーション モードで使用できます。楽観モードでは、Cephable は指定されたアプリ コントロールの音声コントロールに重点を置くように指示されます。楽観モードをオンにすると、音声コントロールはより速くトリガーされますが、正確な単語を言わないと、誤ってコントロールがトリガーされる可能性もあります。楽観モードでは、ディクテーションは使用できません。"
            },
            "confirm": {
                "title": "保存されていない変更があります。",
                "description": "保存されていない変更が検出されました。終了する前に保存しますか?"
            },
            "aiCommands": {
                "title": "インテリジェントな音声コマンド",
                "description": "インテリジェントな音声コマンドにより、Cephable AI は、正確に一致させる必要なしに、使用しようとしている音声コマンドを予測できます。これにより、コンピューターに何をすべきかをより自然に指示することができ、Cephable がそれを理解するのに役立ちます。",
                "option": "インテリジェント音声コマンドを使用しますか?"
            },
            "aiDictation": {
                "title": "インテリジェントなディクテーションとクイックタイプ",
                "description": "インテリジェントなディクテーションとクイックタイプは、デバイス上で最も正確な入力体験を提供します。ディクテーションは句読点、固有名詞、文構造を自動的に処理し、クイックタイプはスマートな予測と修正機能を提供し、簡単かつ正確な入力をサポートします。",
                "option": "インテリジェントディクテーションとクイックタイプを使用しますか?"
            },
            "description": "この接続の音声コマンドとディクテーション設定を管理します。"
        },
        "warn": "マイクが起動されていません。音声コマンドとディクテーションを許可するには、マイクを起動してください。",
        "devices": {
            "error": "マイク入力デバイスが見つかりません。"
        },
        "startDescription": "コマンドの聞き取りを開始するには、マイクをオンにします。"
    },
    "localization": {
        "title": "言語設定",
        "titleShort": "言語",
        "description": "サポートされている言語のリストから希望の言語を選択します。",
        "newUserDescription": "続行する前に、希望する言語を選択します。",
        "edit": "言語の更新",
        "display": {
            "title": "表示言語",
            "description": "Cephable の使用時に表示される言語。これには、選択した言語で表示されるメニュー、通知、アプリのコントロールなどが含まれます。"
        },
        "voice": {
            "title": "音声制御言語",
            "description": "これは、ディクテーションと音声コマンドを認識するときに使用される言語です。言語を指定すると、音声入力の精度が向上します。",
            "settings": {
                "title": "音声認識と表示言語",
                "description": "ディスプレイと音声コントロールの両方の言語設定を調整します。このオプションを使用すると、画面上のテキストや、音声コントロールやディクテーションなどのマイクの操作に使用する言語を選択できます。"
            }
        },
        "locales": {
            "en": "English - 英語",
            "en-us": "English (US) - 英語（米国）",
            "es": "Español — スペイン語",
            "fr": "Français — フランス語",
            "it": "Italiano — イタリア語",
            "de": "Deutsch — ドイツ語",
            "ja": "日本語",
            "en-gb": "English (UK) - 英語（英国）",
            "en-in": "English (India) - 英語（インド）"
        },
        "save": {
            "success": "ユーザーのロケール設定が保存されました。",
            "error": "ユーザーのロケール設定の保存中にエラーが発生しました"
        },
        "profile": {
            "view": "変種",
            "title": "アプリ制御言語",
            "question": "どのアプリ制御言語を編集しますか?",
            "description": "一部のアプリコントロールには、異なる言語のバリエーションが用意されています。別の言語に切り替えて編集し、カスタマイズしてください。",
            "change": "言語を変更"
        },
        "unsupported": {
            "title": "サポートされていない言語 {{locale}}",
            "description": "選択した言語はサポートされていません。別の言語を選択してください。"
        },
        "select": "言語を選択",
        "localesShort": {
            "en": "英語",
            "en-us": "英語（米国）",
            "es": "スペイン語",
            "fr": "フランス語",
            "it": "イタリア語",
            "de": "ドイツ語",
            "ja": "日本語"
        }
    },
    "editor": {
        "title": "マークダウンエディター",
        "bold": "大胆な",
        "italic": "イタリック",
        "underline": "下線",
        "strikethrough": "取り消し線",
        "hr": "水平線",
        "link": "リンク",
        "quote": "引用",
        "code": "コード",
        "codeBlock": "コードブロック",
        "comment": "コメント",
        "image": "画像",
        "table": "テーブル",
        "unordered-list": "順序なしリスト",
        "ordered-list": "順序付きリスト",
        "checked-list": "チェックリスト",
        "help": "ヘルプ",
        "edit": "編集",
        "live": "ライブ",
        "preview": "プレビュー",
        "fullscreen": "全画面表示",
        "placeholder": "ここに Markdown テキストを入力してください..."
    },
    "resume": "再開する",
    "panel": {
        "title": "頭蓋骨パネル",
        "question": "自動起動パネル?",
        "position": {
            "top": "トップ",
            "right": "右",
            "left": "左",
            "bottom": "底 ",
            "description": "Cephable パネルを画面上のどこに表示するかを選択します。",
            "label": "位置"
        },
        "sections": {
            "description": "パネル内の表示するセクションを選択します。好みに応じてセクションを非表示にすることで、パネルのスペースを最大限に活用できます。",
            "microphone": "マイクと音声コントロール",
            "camera": "カメラと顔/頭のコントロール",
            "profile": "アプリのコントロールとプレビュー",
            "globalControls": "グローバルおよびデバイスコントロール",
            "tasks": "インテリジェントタスク",
            "buttons": "クイックアクションボタン"
        },
        "titleShort": "パネル",
        "description": "これはメインのコントロールセンターとなるパネルです。常に表示されており、音声を使ってアプリなどを操作できます。まずはマイクから始めましょう。"
    },
    "textGeneration": {
        "settings": "テキスト生成設定",
        "edit": {
            "title": "テキスト生成設定の編集",
            "description": "インテリジェント テキスト生成の設定を調整して、最適な出力を作成できます。",
            "autoStart": {
                "title": "自動的にウォームアップテキストを生成する",
                "description": "この設定をオンにすると、Cephable AI はテキスト生成に使用される AI モデルを自動的にウォームアップします。モデルをウォームアップすると、生成コマンドを使用するときにパフォーマンスが速くなりますが、コンピューターのリソースの消費量が増えます。この設定をオフにするとリソースは節約されますが、テキスト生成が遅くなる可能性があります。",
                "option": "テキスト生成 AI モデルを自動ウォームアップしますか?"
            },
            "prompt": {
                "title": "テキスト生成に関する追加情報",
                "description": "Cephable の AI でテキストを生成するために使用する追加の詳細を入力します。このフィールドを使用して、トーン、書き方、その他の詳細に関する設定を入力します。",
                "field": "追加のプロンプト",
                "placeholder": "たとえば、フレンドリーな口調で、プロフェッショナルのように、簡潔かつ要点を押さえて書きます。コードを書くときは、思慮深いコメントを残しますが、多すぎないようにします。"
            },
            "enableTextGen": {
                "title": "インテリジェントテキスト生成を有効にする",
                "description": "この設定をオンにすると、Cephable AI はテキスト生成デバイス コントロールを使用して、任意のアプリでテキストを生成できるようになります。これをオフにすると、このコマンドは無効になります。",
                "option": "インテリジェントテキスト生成を使用しますか?"
            },
            "terminate": {
                "title": "クリアテキスト生成リソース",
                "description": "クリックすると、テキスト生成に使用されたリソースがクリアされます。これにより、コンピューターのリソースが解放されますが、次回使用するときにテキスト生成が遅くなる可能性があります。",
                "button": "リソースをクリア",
                "success": "テキスト生成リソースをクリアしています。",
                "confirm": {
                    "title": "クリアテキスト生成リソース",
                    "description": "テキスト生成に使用されたリソースをクリアしてもよろしいですか? これにより、コンピューターのリソースが解放されますが、次回使用するときにテキスト生成が遅くなる可能性があります。",
                    "confirm": "はい、明確なリソース",
                    "cancel": "キャンセル"
                }
            },
            "clearModelCache": {
                "title": "クリアテキスト生成モデルキャッシュ",
                "description": "クリックすると、テキスト生成に使用される AI モデルのキャッシュがクリアされます。これにより、コンピューターのストレージが解放されますが、Cephable はファイルを再ダウンロードする必要があるため、次回使用時にテキスト生成が遅くなる可能性があります。",
                "button": "モデルキャッシュをクリア",
                "success": "ローカル モデル ファイルを削除しました。",
                "confirm": {
                    "title": "クリアテキスト生成モデルキャッシュ",
                    "description": "テキスト生成に使用される AI モデルのキャッシュをクリアし、システムからファイルを削除しますか? この場合、Cephable がファイルを再ダウンロードする必要があるため、次回テキスト生成を使用するときに速度が遅くなります。",
                    "confirm": "はい、ファイルを削除します",
                    "cancel": "キャンセル"
                },
                "error": "ローカル モデル ファイルの削除中にエラーが発生しました。"
            },
            "enableHistory": {
                "title": "テキスト生成履歴を有効にする",
                "description": "この設定をオンにすると、Cephable AI はテキスト生成履歴を使用して、以前のアクションのコンテキストでテキストを生成します。",
                "option": "テキスト生成履歴を使用しますか?"
            }
        },
        "prompt": {
            "systemPrompt": "あなたは役に立つテキスト生成アシスタントであり、ユーザーが使用しているアプリにユーザーに代わってテキストを生成します。生成されたテキストには詳細、説明、または余分なものを提供しないでください。生成するように要求されたものだけを提供してください。特に要求されない限り、マークダウンを使用しないでください。コードを生成するように要求された場合、生成されたコードの説明やコードの周りのマークダウン記号を提供しないでください。ユーザーが要求する生成されたコンテンツのみを提供し、他には何も提供しないでください。マークダウンのチェックマークと言語は使用しないでください。コードのみ - これは非常に重要です。",
            "appName": "現在、{{appName}} のテキストを生成しています。",
            "userPreferences": "テキストの生成方法に関するユーザー設定を尊重します: {{userPreferences}}。"
        },
        "rewritePrompt": {
            "systemPrompt": "あなたは役に立つテキスト生成アシスタントとして、ユーザーが使用しているアプリにユーザーに代わってテキストを生成します。生成されたテキストには、詳細、説明、または余計な情報は一切提供しないでください。生成を依頼されたものだけを提供してください。特に指示されない限り、マークダウンは使用しないでください。コード生成を依頼された場合は、生成されたコードの説明やコードの前後にマークダウン記号は使用せず、ユーザーが要求する生成コンテンツのみを提供してください。マークダウンのチェックマークや言語は使用しないでください。コードのみを提供してください。これは非常に重要です。ユーザーがテキストの一部を書き換えてほしいと依頼された場合は、書き換えるテキストのみを提供してください。",
            "appName": "現在、{{appName}} のテキストを生成しています。",
            "userPreferences": "テキストの生成方法に関するユーザー設定を尊重します: {{userPreferences}}。",
            "userPrompt": "{{userRequestText}} を書き換える: {{clipboardText}}"
        },
        "translatePrompt": {
            "systemPrompt": "あなたは役に立つテキスト翻訳アシスタントとして、ユーザーが使用しているアプリにユーザーに代わってテキストを生成します。生成または翻訳されたテキストには、詳細、説明、または余分な情報を含めないでください。翻訳を依頼されたものだけを提供してください。特に依頼されない限り、マークダウンは使用しないでください。翻訳またはコード生成を依頼された場合、生成されたコードの説明やコードの前後のマークダウン記号は提供せず、ユーザーが求める翻訳内容のみを提供してください。マークダウンのチェックマークや言語は使用しないでください。コードのみを提供してください。これは非常に重要です。ユーザーはテキストの翻訳を依頼しますが、提供するのは翻訳のみです。",
            "appName": "現在、{{appName}} のテキストを翻訳しています。",
            "userPreferences": "テキストの生成方法に関するユーザー設定を尊重します: {{userPreferences}}。",
            "userPrompt": "これを {{language}} に翻訳: {{userRequestText}}",
            "genericUserPrompt": "翻訳: {{userRequestText}}"
        },
        "disabled": {
            "title": "インテリジェントタスクが無効になっています",
            "description": "インテリジェントタスクが無効になっているようです。設定を更新して、テキスト生成、書き換えなどの機能を有効にしてください。"
        }
    },
    "profile": {
        "title": "アプリコントロール",
        "titlePlural": "アプリコントロール",
        "titlePreview": "コントロールのプレビュー",
        "previous": "以前のアプリコントロール",
        "manage": "アプリコントロールの管理",
        "view": "コントロールの表示",
        "edit": "アプリコントロールを編集",
        "add": "アプリコントロールを追加する",
        "create": "アプリコントロールを作成する",
        "warn": "アプリのコントロールを使用するには、カメラまたはマイクを起動する必要があります。",
        "descriptionShort": "Cephable がデバイスやソフトウェアの制御に役立つさまざまな方法をご紹介します。",
        "name": "アプリ名",
        "nameQuestion": "これらのアプリコントロールを何と呼びますか?",
        "newName": "新しいアプリコントロール",
        "search": "アプリコントロールを名前で検索",
        "searchLong": "名前または説明でアプリコントロールを検索する",
        "keyboardAndMouse": "キーボードとマウス",
        "genericController": "ゲームパッドコントローラー",
        "keyboardMouseAndController": "キーボード、マウス、コントローラー",
        "permissionError": "これらのアプリ コントロールを使用する権限がありません。",
        "set": {
            "title": "アプリのコントロールがまだ設定されていないようです。",
            "cta": "アプリコントロールを設定する",
            "empty": {
                "auto": "コントロールを表示するには別のアプリに切り替えてください",
                "select": "開始するにはコントロールを選択してください",
                "none": "アプリコントロールが見つかりません"
            },
            "description": "アプリコントロールは、Cephableが何を検知し、どのようなアクションを実行するかを判断するためのものです。コントロールアプリのコントロールは、ホームページまたは接続設定からいつでも切り替えることができます。"
        },
        "summary": {
            "title": "アプリコントロールの概要",
            "descriptionLong": "これらのアプリ コントロールの詳細は次のとおりです。コントロール、アクションなどを検索して、これらのアプリ コントロールで何ができるかを確認できます。",
            "description": "コントロールの内容、カスタマイズ、詳細など、これらのアプリ コントロールの概要を取得します。",
            "view": "アプリコントロールの概要を表示",
            "filter": "入力タイプでフィルタリング",
            "placeholder": "コントロール名を検索..."
        },
        "copy": {
            "title": "アプリコントロールをコピー",
            "duplicate": "重複したアプリコントロール",
            "question": "コピーを作成しますか?",
            "description": "これらのアプリ コントロールの新しいコピーを作成しますか? こうすると、これらのアプリ コントロールがコピーされた新しいウィンドウが開きますが、保存するまでアカウントに追加されません。",
            "confirm": "はい、コピーを作成します",
            "profileSuffix": "{{name}} (コピー)"
        },
        "new": {
            "title": "新しいアプリコントロールを作成する",
            "description": "コントロールを一から作成するか、最先端の AI でパーソナライズされたコントロールを生成して、音声、頭、顔のジェスチャーを使用してアプリやソフトウェアを簡単に操作できるようにします。",
            "note": "上級ユーザーにおすすめです。",
            "scratch": "ゼロから作成"
        },
        "advancedOptions": "高度な制御オプション",
        "delete": {
            "title": "アプリコントロールの削除",
            "titleLong": "これらのアプリコントロールを削除する",
            "description": "「アプリ コントロールを削除」をクリックすると、これらのアプリ コントロールを削除できます。",
            "confirm": "これらのアプリコントロールを削除してもよろしいですか?",
            "confirmLong": "これらのアプリ コントロールを削除すると、元に戻すことはできません。これらのアプリ コントロールを削除してもよろしいですか?",
            "confirmButton": "はい、これらのアプリコントロールを削除します"
        },
        "current": "現在のコントロール",
        "loading": "コントロールを読み込んでいます...",
        "null": "アプリ コントロールはまだありません。以下をクリックして作成してください。",
        "nullButton": "最初のアプリコントロールを作成する",
        "preview": "プレビュー",
        "features": "特徴",
        "byline_public": "著者: Cephable チーム",
        "byline_shared": "共有者: Cephable コミュニティ",
        "share": {
            "title": "アプリコントロールを共有する",
            "previewTitle": "共有アプリコントロールのプレビュー",
            "description": "これらのアプリ コントロールを他のユーザーと共有すると、他のユーザーがコピーを取得してそこからカスタマイズできるようになります。",
            "descriptionLong": "これらのアプリ コントロールを他のユーザーと共有すると、他のユーザーがコピーを取得してそこからカスタマイズできるようになります。共有方法を選択し、他のユーザーに送信するリンクを作成します。",
            "add": "共有リンクを作成する",
            "confirm": "このURLを共有する",
            "link": "リンクを共有",
            "copy": "リンクをコピー",
            "copied": "コピーしました！",
            "usage": "使用量",
            "created": "{{value}} を作成しました",
            "expiration": {
                "title": "有効期限",
                "once": "1回のみ使用可能",
                "unlimited": "無制限の使用を許可する",
                "no": "有効期限なし",
                "date": "有効期限",
                "dateDescription": "特定の日付に期限切れになる"
            },
            "manage": "以前の共有リンクを管理する",
            "empty": "これらのアプリ コントロールの共有は作成されていません。"
        },
        "swap": {
            "title": "スワップコントロール",
            "titleLong": "アプリのコントロールを入れ替える",
            "descriptionShort": "使用しているプログラムやソフトウェアに合わせて、さまざまなアプリ コントロールを使用します。",
            "description": "使用しているプログラムやソフトウェアに合わせて、さまざまなアプリ コントロールを切り替えることができます。"
        },
        "autoProfileSwitching": {
            "title": "自動制御切り替え",
            "alerts": {
                "disabled": "自動制御切り替えがオフになっています。",
                "temporarilyDisabled": "自動制御切り替えが一時的にオフになっています。",
                "enabled": "自動制御切り替えがオンになっています。",
                "error": "自動コントロール切り替え設定の保存中にエラーが発生しました"
            },
            "associatedPrograms": {
                "add": "新しい関連プログラムを追加する",
                "description": {
                    "personal": "これらのコントロールに接続するソフトウェアまたはプログラムを選択します。これは自動コントロール切り替えをサポートしており、Cephable はこれらのアプリ コントロールを現在使用しているプログラムに合わせて自動的に切り替えます。",
                    "short": "これらのコントロールに接続するソフトウェアまたはプログラムを選択します。"
                },
                "edit": "関連プログラムを編集する",
                "noOptionsText": "関連するプログラムを検索するには入力を開始してください",
                "profileLabel": "アプリコントロール:",
                "remove": "関連プログラムを削除する",
                "title": "関連プログラム",
                "when": "Cephable を使用すると、アプリのコントロールが {{profileName}} に自動的に切り替わります...",
                "emptySearch": "これらのコントロールに関連付けられたプログラムはありません。",
                "error": "関連プログラムの保存中にエラーが発生しました。しばらくしてからもう一度お試しください。",
                "emptyError": "空の関連プログラムが検出されました。続行する前に削除してください。"
            },
            "commandOverlay": {
                "command": "アプリコントロールの切り替え: {{value}}"
            },
            "description": "自動コントロール切り替えにより、Cephableはユーザーのワークフローにシームレスに適応します。オンにすると、Cephableは使用しているプログラムやソフトウェアに応じてアプリのコントロールを調整します。オフにした場合は、「コントロールの切り替え」ボタンまたはグローバルコマンドを使用して、アプリのコントロールを手動で切り替えることができます。"
        },
        "error": {
            "noMatch": "検索に一致するアプリ コントロールはありません。",
            "load": "アプリコントロールの読み込み中にエラーが発生しました。",
            "add": "アプリコントロールの追加中にエラーが発生しました。",
            "delete": "アプリコントロールの削除中にエラーが発生しました。",
            "audioEventsWithEmptyCommands": "トークバックにコントロールがありません。トークバック コントロールをチェックして、完全に入力されていることを確認してください。",
            "conflicts": "競合のため、アプリ コントロールの保存中にエラーが発生しました。",
            "save": "アプリコントロールの保存中にエラーが発生しました。もう一度お試しください。",
            "device": "この接続では無効なアプリコントロールです。別のアプリコントロールをお試しください。"
        },
        "conflictIndicators": {
            "errorTitle": "競合によりアプリコントロールの保存中にエラーが発生しました",
            "warningTitle": "アプリコントロールは警告付きで保存されました",
            "subtitle": "作成したアプリ コントロールには、競合する可能性のある構成がいくつかあります。",
            "profileNameErrors": "アプリコントロールの名前の競合",
            "emptyControlsMapped": "入力名が空です",
            "emptyControlsMappedDescription": "入力には音声コマンド、表情、頭の傾き、その他のコマンドを追加してください。",
            "emptyKeybindingControlsMapped": "キーバインドの空の入力名",
            "emptyKeybindingControlsMappedDescription": "キーバインドの入力に音声コマンド、表情、頭の傾き、またはその他のコマンドを追加してください。",
            "duplicateNameTitle": "アプリコントロール名が重複しています",
            "duplicateNameDescription": "同じ名前の既存のアプリ コントロールがあります。続行する前に名前を変更してください。",
            "emptyNameTitle": "アプリコントロール名が空です",
            "emptyNameDescription": "アプリ コントロールには名前を付ける必要があります。例: Game 1、Spotify、Word など。",
            "macrosReleaseKeysMissingTitle": "未リリースのキーの出力",
            "macrosReleaseKeysMissingDescription": "キーが動かなくなるのを防ぐには、リリース キーを追加するか、すべてのステップを停止してください。",
            "duplicateInputCommandMacroTitle": "同一の制御入力",
            "duplicateCommandsDescription": "重複する入力コマンドを削除するか変更してください。",
            "duplicateInputCommandBindingsTitle": "キーバインディングの同一のコントロール入力",
            "conflictIndicatorDisplayString": "{{container}} : {{commandOrKeyName}} と {{commandOrEventType}}",
            "duplicateMacroNames": "重複したコントロール名",
            "duplicateMacroNamesDescription": "同一のコントロール名のいずれかを削除するか変更してください。",
            "warningIgnore": "無視する",
            "warningDoNotShowAgain": "再度警告を表示しない",
            "macrosVoiceCommandConflictWithDictationTitle": "ディクテーションキーワードと同じように音声コマンドをコントロールします",
            "keybindingsVoiceCommandConflictWithDictationTitle": "キーバインド音声コマンドはディクテーションキーワードと同じです",
            "macrosVoiceCommandConflictWithDictationDescription": "音声入力により、ディクテーションと音声コマンドがトリガーされます。",
            "keybindingsVoiceCommandConflictWithDictationDescription": "音声入力により、ディクテーションとキーの押下がトリガーされます。",
            "macrosVoiceCommandConflictWithGenerationTitle": "生成キーワードと同じ音声コマンドを制御する",
            "keybindingsVoiceCommandConflictWithGenerationTitle": "キーバインド音声コマンドは生成キーワードと同じ",
            "macrosVoiceCommandConflictWithGenerationDescription": "音声入力により、生成と音声コマンドがトリガーされます。",
            "keybindingsVoiceCommandConflictWithGenerationDescription": "音声入力により、生成とキーの押下がトリガーされます。",
            "duplicateAssociatedProgramNames": "関連プログラム名が重複しています",
            "duplicateAssociatedProgramNamesDescription": "同一の関連プログラムの 1 つを削除するか変更してください。",
            "emptyEvent": {
                "title": "不足している手順",
                "description": "コントロールに不足している手順があります。これにより、コマンドを発行しても Cephable がアクションを実行しない可能性があります。"
            }
        },
        "success": {
            "save": "アプリのコントロールが保存されました。",
            "add": "アプリコントロールが追加されました。",
            "delete": "アプリコントロールが削除されました。",
            "share": "共有リンクが作成され、クリップボードにコピーされました",
            "shareDelete": "共有リンクが削除されました。",
            "generate": "アプリコントロールが生成されました。"
        },
        "warning": "アプリコントロールは警告付きで保存されました",
        "customize": "アプリコントロールをカスタマイズする",
        "custom": "{{name}} (カスタム)",
        "description": "アプリコントロールは、デバイスや接続を制御するために使用できるコントロールのセットです。複数のアプリコントロールを作成し、いつでも切り替えることができます。"
    },
    "publicProfiles": {
        "toolbar": "アプリコントロールを探索",
        "title": "アプリコントロールを探索",
        "offline": {
            "title": "パブリック アプリ コントロールを読み込めません",
            "description": "オフラインのようです。アプリ コントロールは引き続き使用できますが、新しいパブリック アプリ コントロールを読み込むことはできません。",
            "confirm": "わかった"
        },
        "announcement": "{{count}} 個の新しいアプリコントロールが読み込まれました",
        "description": {
            "personal": "パブリック アプリ コントロールを使用すると、お気に入りのアプリで Cephable をすぐに使い始めることができます。デフォルトのコントロールを使用することも、ニーズに合わせてカスタマイズすることも、まったく新しいカスタム アプリ コントロールを最初から作成することもできます。",
            "pro": "パブリック アプリ コントロールを使用すると、お気に入りのアプリで Cephable をすぐに使い始めることができます。デフォルトのコントロールを使用したり、ニーズに合わせてカスタマイズしたり、コントロール ジェネレーターを使用してまったく新しいカスタム アプリ コントロールを作成したりできます。"
        },
        "team": "セファブルチーム"
    },
    "publicTag": "公共",
    "tray": {
        "panel": "トグルパネル",
        "dashboard": "ダッシュボードを表示",
        "quit": "Cephable を終了する"
    },
    "generate": "生成する",
    "stop": "停止",
    "clear": "クリア",
    "rewrite": "リライト",
    "translate": "翻訳する",
    "smartTasks": {
        "title": "インテリジェントタスク",
        "show": "インテリジェントタスクを表示",
        "description": "インテリジェントタスクとは、CephableのAIがあなたに代わって実行できる様々なタスクです。これらのタスクはデバイス上のAIによって実行され、テキストの作成、要約、書き直し、翻訳、メモの作成、ドキュメントを使ったチャットなどに利用できます。",
        "generateText": {
            "title": "テキスト生成",
            "description": "入力またはプロンプトに基づいてテキスト コンテンツを作成します。",
            "label": "何を生成したいのか説明してください"
        },
        "summarizeText": {
            "title": "テキストを要約する",
            "description": "長いテキストを簡潔な要約にまとめます。",
            "directions": "要約するテキストを入力するか、強調表示したテキストを Cephable が自動的に使用します。"
        },
        "rewriteText": {
            "title": "テキストの書き換え",
            "description": "別のアプリで書き込んでいるテキストをハイライト表示してから、ここに戻って、どのように書き直したいかを説明します。",
            "label": "テキストをどのように書き直したいか説明してください",
            "inputLabel": "書き換えるテキストを入力してください"
        },
        "translateText": {
            "title": "テキストを翻訳する",
            "description": "翻訳するテキストを入力するか、強調表示したテキストを Cephable が自動的に使用します。",
            "label": "翻訳するテキストを入力してください",
            "languageLabel": "翻訳先の言語"
        },
        "noteTaker": {
            "title": "メモテイカー",
            "description": "Cephableで会議や会話をローカルで録音・書き起こしましょう"
        },
        "documentChat": {
            "title": "ドキュメントチャット",
            "description": "ドキュメントを操作してクエリを実行し、すぐに洞察を得ることができます。"
        },
        "highlightText": {
            "title": "強調表示されたテキストを使用する",
            "description": "Cephableは、アプリでハイライトしたテキストを自動的に使用して、要約、書き直し、翻訳などのタスクを実行します。必要に応じて、手動でテキストを入力することもできます。",
            "label": "使用するテキストを入力してください",
            "placeholder": "別のアプリでテキストをハイライトし、ここに戻って使用することもできます。"
        },
        "pasteText": {
            "title": "テキストを貼り付ける",
            "description": "Cephableは、クリップボードにコピーしたテキストを自動的に使用して、要約、書き直し、翻訳などのタスクを実行します。必要に応じて、手動でテキストを入力することもできます。",
            "label": "使用するテキストを入力してください",
            "placeholder": "別のアプリでテキストをハイライトし、ここに戻って使用することもできます。"
        },
        "clearCache": "生成時に問題が発生した場合は、テキスト生成設定からキャッシュとリソースをクリアして、もう一度お試しください。",
        "transcribeAudio": {
            "title": "音声を書き起こす",
            "description": "AI トランスクリプションを使用して、オーディオ ファイルまたはビデオ ファイルをテキストに変換します。",
            "inputMethod": "入力方法を選択",
            "localFile": "ローカルファイル",
            "url": "URL",
            "selectFile": "オーディオ/ビデオファイルを選択",
            "urlLabel": "オーディオ/ビデオURL",
            "transcribe": "転写",
            "result": "転写結果",
            "invalidFileType": "有効なオーディオまたはビデオファイル（mp3、wav、ogg、mp4、webm、mov、avi）を選択してください",
            "error": "転記エラー",
            "history": {
                "title": "転写履歴",
                "description": "保存した文字起こしを表示および管理します。",
                "viewHistory": "履歴を表示",
                "empty": "まだ書き起こしがありません。書き起こしを始めて、歴史を築きましょう。",
                "titleLabel": "タイトル（オプション）",
                "titlePlaceholder": "この転写のタイトルを入力してください",
                "textLabel": "転写テキスト",
                "confirmDelete": "この転写を削除してもよろしいですか?"
            }
        }
    },
    "inputMethod": "入力方法:",
    "hotkey": {
        "title": "クイックアクションボタン",
        "titlePlural": "クイックアクションボタン",
        "titlePanel": "クイックアクション",
        "label": "クイックアクションボタンの表示名",
        "placeholder": "表示する名前",
        "question": "このボタンにどんな名前を付けますか?",
        "when": "タップすると…",
        "description": "クイックアクションボタンを使用すると、コンパニオンアプリからタップするボタンを作成できます。ボタンは必要な数だけ作成でき、スマートフォンやタブレットの画面いっぱいに表示されます。",
        "usagePrompt": "クイックアクションボタンは、スマートフォンやタブレットからコンパニオンアプリでアクセスできます。モバイルアプリはGoogle PlayまたはiOS App Storeからダウンロードできます。",
        "reorder": "上へ移動ボタンと下へ移動ボタンを使用して順序を並べ替えることができます。",
        "emptyTitle": "クイックアクションボタンなし",
        "edit": "クイックアクションボタンの編集",
        "tap": "{{value}}をタップ",
        "copySuffix": "{{name}}_コピー",
        "hotkeysOnly": "カスタムボタン",
        "allControls": "すべてのアプリコントロール",
        "show": "クイックアクションボタンを表示",
        "deprecatedDialog": {
            "title": "アプリのコントロールを更新する必要があります。",
            "description2": "たった1秒の簡単なアップデートで、シームレスなボタンカスタマイズ体験をお楽しみいただけます。面倒な手順はもう不要。よりユーザーフレンドリーなインターフェースがあなたを待っています。さあ、乗り換えの準備はできていますか？",
            "confirm": "やりましょう！",
            "description1": "クイックアクションボタン付きの古いアプリコントロールをご利用のようですね。エキサイティングなアップデートをご用意しました！システムを刷新し、クイックアクションボタンの作成と編集が簡単になりました。もう詳細な設定に煩わされることはありません。"
        },
        "demo": {
            "title": "デモのクイックアクションボタン",
            "step1": "クイックアクションボタンをオンにする",
            "step2": "テキスト ブロックを制御するには、以下のサンプル プロンプトを使用します。",
            "command1": "ボタン1を押すと「文字を大きくする」",
            "command2": "ボタン2を押すと「太字」になります",
            "command3": "",
            "continue": "クイックアクションボタンで続行",
            "description": "以下のデモエリアでは、クイックアクションボタンを試すことができます。デモでは、以下のテキストエリアの操作のみに限定されています。"
        },
        "example": {
            "title": "クイックアクションボタンの例",
            "command1": "一時停止をタップ",
            "example1": "例：「ビデオを一時停止」",
            "command2": "「進む」をタップ",
            "example2": "「ズームアウト」の例",
            "command3": "タップストップ",
            "example3": "例：「ウィンドウを閉じる」",
            "description": "これらの例は、デバイスや接続を制御するクイックアクションボタンの汎用性を示しています。コマンドの実行、インターフェースの操作、あるいはタップするだけでアクションを実行できます。"
        },
        "emptySearch": "この条件に一致するクイックアクションはありません。",
        "empty": "現在、クイックアクションがないようです。",
        "emptyLong": "これらのアプリコントロールにはクイックアクションボタンが設定されていません。クイックアクションボタンを追加するか、クイックアクションボタンを含むアプリコントロールを選択すると、ここに表示されます。"
    },
    "reset": "リセット",
    "info": "詳細情報",
    "device": {
        "title": "繋がり",
        "titlePlural": "接続",
        "status": {
            "title": "接続ステータス:",
            "connected": {
                "application": "接続されたアプリケーション",
                "connection": "接続",
                "device": "接続されたデバイス",
                "game": "コネクテッドゲーム"
            },
            "disconnected": {
                "application": "切断されたアプリケーション",
                "connection": "切断",
                "device": "切断されたデバイス",
                "game": "切断されたゲーム"
            }
        },
        "running": "ランニング",
        "offline": "オフライン",
        "otherDevices": "その他の出力接続",
        "currentStatus": "現在のステータス:",
        "connectionStatus": "接続ステータス:",
        "profileStatus": "現在のアプリのコントロール:",
        "name": {
            "title": "接続名",
            "question": "この接続を何と呼びますか?",
            "description": "後で簡単に見つけられるように、接続に名前を付けます。",
            "placeholder": "接続名",
            "edit": "接続名を編集"
        },
        "updates": {
            "title": "接続の更新",
            "settings": "接続更新設定",
            "description": "接続ファームウェアのアップデートを確認し、自動アップデート設定を変更します",
            "edit": "更新設定を編集する",
            "check": {
                "title": "アップデートを確認する",
                "processing": "アップデートを確認しています。数分かかる場合があり、アップデート中に接続が再開されることがあります。",
                "description": "タップして接続のアップデートを確認してください。アップデートが利用可能で、接続がアクティブな場合は、アップデートが開始されます。アップデートには数分かかる場合があります。"
            },
            "auto": {
                "title": "自動更新",
                "description": "この設定をオンにすると、電源に接続し、Wi-Fiに接続し、アップデートが利用可能な場合、自動的に接続が更新されます。オフの場合は、アップデートボタンをタップして最新の状態にする必要があります。",
                "option": "自動更新を使用しますか?"
            }
        },
        "delete": {
            "title": "{{name}} のリンクを解除",
            "titleLong": "アカウントのリンクを解除",
            "description": "リンクを解除すると、Cephableとこのコンピューターまたはゲームの接続が切断され、アカウントからも削除されます。接続、コマンドの送信、アップデートはできなくなります。この操作は元に戻せませんが、将来再び使用したい場合は、同じコンピューターまたはゲームへの新しい接続を作成できます。",
            "confirm": "この接続を解除してもよろしいですか?",
            "confirmLong": "この接続を登録解除してリセットしてもよろしいですか？ 今後、この接続に接続したり、コマンドを送信したり、更新したりできなくなります。登録解除とリセットを行うと、他のユーザーがこの接続を最初から設定できるようになります。",
            "confirmButton": "はい、この接続を削除します。"
        },
        "manage": {
            "title": "クリックすると、接続の詳細を表示および管理できます。",
            "description": "",
            "name": "管理を容易にするために接続名をカスタマイズします。"
        },
        "error": {
            "save": "接続の保存中にエラーが発生しました。",
            "load": "接続の読み込み中にエラーが発生しました。",
            "add": "接続の追加中にエラーが発生しました。",
            "delete": "接続の削除中にエラーが発生しました。",
            "updates": "更新の確認中にエラーが発生しました。",
            "connection": "接続が確立されていません。再試行する前に接続されていることを確認してください。",
            "deleteLong": "この接続をアカウントから削除できませんでした。このアカウントに再度ログインする場合は、接続設定でこの接続を手動で削除する必要がある場合があります。"
        },
        "success": {
            "save": "接続が保存されました。",
            "add": "接続が追加されました。",
            "delete": "接続が削除されました。"
        },
        "description": "Cephableは複数のデバイスと接続をサポートしています。設定を管理したり、ここからすべてを選択したりできます。このコンピューターは常にメインの接続として使用されます。接続は後で追加できます。",
        "swap": {
            "titlePlural": "スワップ接続"
        },
        "control": {
            "button": "{{name}} をコントロール",
            "description": {
                "application": "音声、クイックアクション、ヘッドモーションなどを使って、接続されたアプリケーションを操作できます。例えば、「保存」と言うと、実行中のアプリケーションが保存されます。",
                "connection": "音声、クイックアクション、ヘッドモーションなどを使って、接続中のデバイスを操作できます。例えば、「保存」と言うと、接続中のデバイスが保存されます。",
                "device": "音声、クイックアクション、ヘッドモーションなどを使って、接続されたデバイスを操作できます。例えば、「Spotifyを開いて」と言うと、起動中のデバイスでSpotifyが開きます。",
                "game": "この接続型ゲームは、音声、クイックアクション、頭の動きなどを使って操作できます。例えば、「Go」と言うと、ランニングゲームでプレイヤーが動きます。"
            },
            "generic": "制御接続"
        },
        "titleShort": "接続する",
        "titleLong": "接続と拡張機能",
        "viewAll": "すべての接続を表示",
        "add": {
            "short": "伸ばす",
            "title": "新しい接続または拡張機能を追加する",
            "description": "接続と拡張機能は、Cephableの体験をさらに充実させる方法です。新しい接続を追加することで、より多くのデバイス、アプリケーション、ゲームに接続できます。接続と拡張機能を追加することで、Cephableの体験を次のレベルに引き上げましょう。",
            "action": "新しい接続を追加する"
        },
        "new": "新しい接続ができました!"
    },
    "explore": "探検する",
    "shortcuts": {
        "title": "グローバルショートカット",
        "description": "キーボード ショートカットをカスタマイズして、システム上のどこからでも Cephable コントロールにすばやくアクセスできます。",
        "info": "これらのショートカットはグローバルに機能し、Cephable がアクティブウィンドウでない場合でも使用できます。",
        "shortcut": "ショートカット",
        "toggleMicrophone": "マイクを切り替える",
        "toggleDictation": "ディクテーションモードを切り替える",
        "toggleVoiceControl": "音声制御モードを切り替える",
        "togglePanel": "トグルパネル",
        "registrationFailed": "一部のグローバルショートカットを登録できませんでした。他のアプリケーションで使用されている可能性があります。",
        "record": {
            "title": "ショートカットを記録",
            "start": "クリックして記録",
            "listening": "希望するキーの組み合わせを押してください...",
            "pressKeys": "今すぐキーを押してください"
        },
        "formatHint": "少なくとも 1 つの修飾キー ({{modifierKey}}, {{modifierKey2}}, Shift) と他の 1 つのキーを選択します。"
    },
    "gamepad": {
        "title": "ゲームパッドのサポート",
        "description": "PCゲーム用のゲームパッドとジョイスティックの出力を構成する",
        "driver": {
            "description": "ゲームコントローラー出力をサポートするには、Cephable で ViGEm と呼ばれる外部ドライバーをダウンロードしてインストールする必要があります。このドライバーは、ゲームがネイティブに認識する仮想 Xbox 360 コントローラー機能を有効にします。",
            "installed": "ゲームコントローラードライバーがインストールされました。ゲームパッドの出力が使用できるようになりました。それでも問題が解決しない場合は、ドライバーを再インストールしてみてください。",
            "notInstalled": "ゲームコントローラのドライバーがインストールされていません",
            "install": "ゲームコントローラドライバをインストールする",
            "reinstall": "ゲームコントローラドライバを再インストールする",
            "installing": "ViGEm ゲーム コントローラー ドライバーをインストールしています...",
            "installSuccess": "ViGEm ゲーム コントローラー ドライバーが正常にインストールされました。これで、コントロールでゲームパッドの出力を使用できるようになりました。",
            "installFailed": "ViGEmドライバのインストールに失敗しました。もう一度お試しいただくか、ViGEmウェブサイトから手動でインストールしてください。"
        },
        "platform": {
            "unsupported": "ゲームパッドの機能はプラットフォームによってサポートされていません",
            "unsupportedDescription": "ゲームパッド出力機能は現在、Windows x64 システムでのみサポートされています。Windows ARM64 のサポートは、SDK の制限によりまだ利用できません。"
        },
        "usage": "ゲーム コントローラー ドライバーをインストールすると、マクロや音声コマンドでジョイスティックの動きやゲームパッドのボタンの押下を使用してゲームを制御できるようになります。"
    },
    "youtube": {
        "unavailable": {
            "title": "ビデオは利用できません",
            "description": "この動画は現在ご利用いただけません。後ほどもう一度ご確認ください。",
            "retry": "リトライ"
        },
        "watch": {
            "title": "おっと。",
            "description": "動画の読み込み中に問題が発生したようです。YouTubeで直接視聴できます。",
            "button": "YouTubeで見る"
        },
        "offline": {
            "title": "ビデオは利用できません",
            "description": "このYouTube動画を読み込むにはインターネット接続が必要です。接続を確認してもう一度お試しください。"
        }
    },
    "metrics": {
        "download": {
            "success": "メトリック ファイルに正常にアクセスしました。",
            "manualPath": "メトリクスファイルは {{path}} で入手できます",
            "error": "メトリック ファイルのダウンロード中にエラーが発生しました。",
            "noFile": "メトリック ファイルが見つかりません。"
        },
        "clear": {
            "success": "メトリック ファイルが正常にクリアされました。",
            "error": "メトリック ファイルの消去中にエラーが発生しました。",
            "noFile": "クリアするメトリック ファイルが見つかりません。",
            "confirm": "すべてのメトリックデータをクリアしてもよろしいですか? 元に戻すことはできません。"
        }
    },
    "suggestedPrompts": {
        "title": "提案されたプロンプト",
        "description": "AI タスクに表示される提案プロンプトをカスタマイズして、すぐに開始できるようにします。",
        "edit": "提案されたプロンプトを編集する",
        "generate": "テキストを生成する",
        "rewrite": "テキストの書き換え",
        "addGenerate": "生成プロンプトを追加する",
        "addRewrite": "書き換えプロンプトを追加する",
        "remove": "プロンプトを削除",
        "generatePlaceholder": "テキスト生成のプロンプトを入力してください...",
        "rewritePlaceholder": "テキスト書き換えのプロンプトを入力してください...",
        "suggested": "提案されたプロンプト",
        "suggestedFor": "{{profileName}} におすすめ",
        "seeAll": "すべてのプロンプトを表示",
        "showLess": "表示を減らす",
        "allPrompts": "すべてのプロンプト",
        "customFor": "{{profileName}} のカスタムプロンプト",
        "defaultPrompts": "デフォルトのプロンプト",
        "defaultGenerate": [
            "新製品を紹介するプロフェッショナルなメール",
            "来週のチームディスカッションの議題",
            "新しい取り組みのためのプロジェクト提案の概要",
            "正式なビジネスレターのテンプレート",
            "技術文書セクション",
            "ユーザーマニュアルの紹介",
            "トレーニングドキュメントの概要",
            "政策文書の草案",
            "会議後のフォローアップメール",
            "顧客への感謝のメッセージ",
            "プロジェクトのステータス更新メール",
            "会社のイベントへの招待状",
            "期限が迫っていることを知らせるリマインダーメール",
            "新しいチームメンバーへの歓迎メール",
            "サービス中断に関するお詫びメール",
            "ニュースレターの紹介",
            "マーケティングキャンペーンのためのブレインストーミングリスト",
            "チームの生産性を向上させる創造的なソリューション",
            "会社の慰安旅行のアイデア",
            "新しいモバイルアプリ機能のコンセプト",
            "顧客体験向上のための提案",
            "製品開発のための革新的なアイデア",
            "ソーシャルメディア投稿のコンテンツアイデア",
            "専門能力開発のためのワークショップのトピック",
            "ユーザー入力を検証する関数",
            "ユーザー管理のためのデータベースクエリ",
            "APIリクエストのエラー処理コード",
            "設定ファイルテンプレート",
            "複雑なアルゴリズムを説明するコメント",
            "新しい機能のユニットテストケース",
            "APIエンドポイントのドキュメント",
            "自動展開用のスクリプト"
        ],
        "defaultRewrite": [
            "このテキストをもっと簡潔に、要点を押さえたものにしましょう",
            "この要約をさらに詳しく記述する",
            "これを番号付きリストとして再フォーマットします",
            "これを箇条書きに変換する",
            "これを明確な段落に再構成する",
            "このテキストを素早くスキャンしやすくします",
            "この情報を階層的に整理する",
            "これをステップバイステップのガイドとしてフォーマットします",
            "このメッセージをよりプロフェッショナルでフォーマルなものにしましょう",
            "これをもっとカジュアルでフレンドリーな感じに書き直してください",
            "より励ましになるよう口調を調整する",
            "もっと自信と断定的な言い方をしましょう",
            "外交的に口調を和らげる",
            "このテキストに熱意とエネルギーを加える",
            "もっと共感的で理解のあるものにしましょう",
            "より協力的な口調で書き直す",
            "一般向けに簡略化する",
            "この説明をより技術的かつ詳細にしてください",
            "この複雑な概念をより単純な言葉で分解する",
            "コンテキストと背景情報をもっと追加する",
            "これを重要なポイントにまとめる",
            "例を挙げて要点を詳しく説明する",
            "初心者にとってよりアクセスしやすいものにする",
            "重要な情報を維持しながらこれを要約する",
            "明瞭性と読みやすさを向上させる",
            "もっと魅力的で興味深いものにしましょう",
            "文法と流れを改善する",
            "メリットを強調するように書き直す"
        ]
    },
    "accessibilityService": {
        "error": {
            "generic": "内部エラーが発生しました。しばらくしてからもう一度お試しください。",
            "elementNotFound": "'{{name}}' に該当する結果は見つかりませんでした。検索が存在することを確認して、もう一度お試しください。",
            "highlightOnConflict": "'{{name}}'という名前の要素が複数見つかりました。選択する要素を指定するようにコマンドを調整してください。",
            "clickNotInitialized": "名前によるタップは現在ご利用いただけません。問題が解決しない場合は、サポートにお問い合わせください。",
            "platformUnsupported": "このプラットフォームでは音声マウス機能はサポートされていません。"
        },
        "clickWait": "初期化中です。しばらくお待ちいただき、もう一度お試しください。"
    },
    "deprecated": "非推奨",
    "view": "ビュー"
}
